<template>
  <div class="pane-config-wrap" @contextmenu="$emit('closeRightMenu')">
    <div class="pane-name">
      <Icon icon="zu33680" class="pane-name-icon"></Icon>
      <span class="pane-name-title">{{ isScreenSettingsPanel ? '大屏设置' : '组件设置' }}</span>
    </div>
    <!-- 组合大屏：菜单 Tab -->
    <el-collapse v-if="componentType === 'compositeTabBar'" v-model="activeNames" class="pane-config-container" @keydown.native="handleKeyDown">
      <el-collapse-item title="尺寸" name="1">
        <div class="component-size">
          <span class="option-size-label">位置</span>
          <span class="opti-sub-label">x</span>
          <el-input-number
            v-model="componentSizeSet.x"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">y</span>
          <el-input-number
            v-model="componentSizeSet.y"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
        <div class="component-size">
          <span class="option-size-label">尺寸</span>
          <span class="opti-sub-label">w</span>
          <el-input-number
            v-model="componentSizeSet.w"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">h</span>
          <el-input-number
            v-model="componentSizeSet.h"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
      </el-collapse-item>
      <el-collapse-item title="子屏页签" name="2">
        <el-button size="mini" type="primary" @click="addCompositeTab">新增页签</el-button>
        <div
          v-for="(tab, idx) in (currentComponent.chartSet.tabs || [])"
          :key="tab.tabId || idx"
          class="border-config"
          style="margin-top:12px;border:1px solid #eee;padding:10px;border-radius:6px;">
          <div class="border-config-item">
            <span class="option-label">标签</span>
            <el-input v-model="tab.label" size="small" maxlength="20" style="width:200px" />
          </div>
          <div class="border-config-item" style="margin-top:8px">
            <span class="option-label">内容类型</span>
            <el-radio-group v-model="tab.type" size="small" @change="(v) => onCompositeTabTypeChange(tab, v)">
              <el-radio-button label="panel">子屏</el-radio-button>
              <el-radio-button label="url">网页链接</el-radio-button>
            </el-radio-group>
          </div>
          <div class="border-config-item" style="margin-top:8px">
            <span class="option-label">{{ (String(tab.type || 'panel') === 'url') ? '链接' : '子屏' }}</span>
            <el-select
              v-if="String(tab.type || 'panel') !== 'url'"
              v-model="tab.panelSn"
              clearable
              filterable
              placeholder="选择数据大屏"
              style="width:260px"
              @focus="onCompositeTabPanelSelectFocus(tab)"
              @change="onCompositeTabPanelSnChange(tab)">
              <el-option
                v-for="op in screenSelectorOptions"
                :key="op.panelSn"
                :label="formatScreenSelectorLabel(op)"
                :value="op.panelSn" />
            </el-select>
            <el-input
              v-else
              v-model="tab.url"
              size="small"
              placeholder="请输入第三方网页链接（https://...）"
              style="width:260px" />
            <el-button type="text" style="margin-left:8px" @click="removeCompositeTab(idx)">删除</el-button>
          </div>
          <div v-if="String(tab.type || 'panel') === 'url'" class="border-config-item" style="margin-top:10px">
            <span class="option-label">边距</span>
            <div class="composite-url-inset-row">
              <div>
                <span class="composite-url-inset-label">上</span>
                <el-input-number
                  :value="compositeTabUrlInsetValue(tab, 'top')"
                  :min="0"
                  :max="5000"
                  size="small"
                  controls-position="right"
                  @change="(v) => setCompositeTabUrlInset(tab, 'top', v)" />
                <span class="composite-url-inset-label">右</span>
                <el-input-number
                  :value="compositeTabUrlInsetValue(tab, 'right')"
                  :min="0"
                  :max="5000"
                  size="small"
                  controls-position="right"
                  @change="(v) => setCompositeTabUrlInset(tab, 'right', v)" />
              </div>
              <div>
                <span class="composite-url-inset-label">下</span>
                <el-input-number
                  :value="compositeTabUrlInsetValue(tab, 'bottom')"
                  :min="0"
                  :max="5000"
                  size="small"
                  controls-position="right"
                  @change="(v) => setCompositeTabUrlInset(tab, 'bottom', v)" />
                <span class="composite-url-inset-label">左</span>
                <el-input-number
                  :value="compositeTabUrlInsetValue(tab, 'left')"
                  :min="0"
                  :max="5000"
                  size="small"
                  controls-position="right"
                  @change="(v) => setCompositeTabUrlInset(tab, 'left', v)" />
              </div>
            </div>
          </div>
        </div>
        <p class="data-rich-tip" style="margin-top:12px;margin-bottom:0">
          组合大屏仅支持嵌套一层：若子屏选「组合」，则该子组合内的页签不能再选组合大屏。
        </p>
      </el-collapse-item>
      <el-collapse-item title="样式" name="3">
        <div class="border-config-item">
          <span class="option-label">底色</span>
          <el-color-picker
            :value="(currentComponent.chartSet.barStyle || {}).barBackground"
            show-alpha
            :predefine="COLOR_PICKER_LIST"
            @input="(v) => ensureCompositeBarStyle('barBackground', v)" />
        </div>
        <div class="border-config-item" style="margin-top:8px">
          <span class="option-label">间距</span>
          <el-input-number
            :value="(currentComponent.chartSet.barStyle || {}).tabGap"
            :min="0"
            :max="48"
            size="small"
            controls-position="right"
            style="width:140px"
            @change="(v) => ensureCompositeBarStyle('tabGap', v)" />
        </div>
        <div class="border-config-item">
          <span class="option-label">文字</span>
          <el-color-picker
            v-model="currentComponent.chartSet.barStyle.color"
            show-alpha
            :predefine="COLOR_PICKER_LIST"
            class="el-color-picker" />
          <el-input-number
            v-model="currentComponent.chartSet.barStyle.fontSize"
            class="title-config-fontsize"
            :min="8"
            :max="200"
            :step="1"
            controls-position="right"
            style="width: 110px" />
        </div>
        <div class="border-config-item">
          <span class="option-label">字体</span>
          <ChartFontFamilySelect v-model="compositeTabBarFontFamilyModel" select-class="title-config-fontfamily" :width="220" />
        </div>
        <div class="border-config-item" style="margin-top:12px">
          <span class="option-label">圆角</span>
          <el-input-number
            :value="(currentComponent.chartSet.barStyle || {}).tabBorderRadius"
            :min="0"
            :max="40"
            size="small"
            controls-position="right"
            style="width:120px"
            @change="(v) => ensureCompositeBarStyle('tabBorderRadius', v)" />
        </div>
        <div class="border-config-item" style="margin-top:8px">
          <span class="option-label">背景</span>
          <el-color-picker
            :value="(currentComponent.chartSet.barStyle || {}).tabBackground"
            show-alpha
            :predefine="COLOR_PICKER_LIST"
            @input="(v) => ensureCompositeBarStyle('tabBackground', v)" />
        </div>
        <p class="data-rich-tip" style="margin:14px 0 6px">激活态</p>
        <div class="border-config-item">
          <span class="option-label">呈现方式</span>
          <el-radio-group v-model="compositeTabBarActivePresentationModel">
            <el-radio label="color">纯色</el-radio>
            <el-radio label="template">标题模版</el-radio>
          </el-radio-group>
        </div>
        <div
          v-if="(currentComponent.chartSet.barStyle || {}).activePresentation === 'template'"
          class="border-config-item"
          style="margin-top:8px;align-items:flex-start">
          <span class="option-label">模版图</span>
          <div class="set-template" style="flex:1">
            <div style="padding:6px 0">
              <img
                :src="COMPOSITE_TAB_BAR_ACTIVE_TEMPLATE_URL"
                alt=""
                style="display:block;max-width:220px;height:auto;border:1px solid #ebeef5;border-radius:4px;background:#0a1629">
            </div>
            <div class="title-border-stretch-row">
              <el-switch
                v-model="compositeTabBarActiveTemplateStretchModel"
                class="title-border-stretch-switch"
                active-text="铺满"
                inactive-text="原比例" />
            </div>
          </div>
        </div>
        <div class="border-config-item" style="margin-top:8px">
          <span class="option-label">激活颜色</span>
          <el-color-picker
            :value="(currentComponent.chartSet.barStyle || {}).activeColor"
            show-alpha
            :predefine="COLOR_PICKER_LIST"
            @input="(v) => ensureCompositeBarStyle('activeColor', v)" />
        </div>
        <div
          v-if="(currentComponent.chartSet.barStyle || {}).activePresentation !== 'template'"
          class="border-config-item"
          style="margin-top:8px">
          <span class="option-label">激活背景</span>
          <el-color-picker
            :value="(currentComponent.chartSet.barStyle || {}).activeBackground"
            show-alpha
            :predefine="COLOR_PICKER_LIST"
            @input="(v) => ensureCompositeBarStyle('activeBackground', v)" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 组合大屏：子屏容器 -->
    <el-collapse v-else-if="componentType === 'compositePanelHost'" v-model="activeNames" class="pane-config-container" @keydown.native="handleKeyDown">
      <el-collapse-item title="尺寸" name="1">
        <div class="component-size">
          <span class="option-size-label">位置</span>
          <span class="opti-sub-label">x</span>
          <el-input-number
            v-model="componentSizeSet.x"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">y</span>
          <el-input-number
            v-model="componentSizeSet.y"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
        <div class="component-size">
          <span class="option-size-label">尺寸</span>
          <span class="opti-sub-label">w</span>
          <el-input-number
            v-model="componentSizeSet.w"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">h</span>
          <el-input-number
            v-model="componentSizeSet.h"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 素材-筛选组件配置 -->
    <el-collapse v-else-if="componentType === 'filterBlock'" v-model="activeNames" class="pane-config-container" @keydown.native="handleKeyDown">
      <!-- 组件尺寸设置 -->
      <el-collapse-item title="尺寸" name="1">
        <div class="component-size">
          <span class="option-size-label">位置</span>
          <span class="opti-sub-label">x</span>
          <el-input-number
            v-model="componentSizeSet.x"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">y</span>
          <el-input-number
            v-model="componentSizeSet.y"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
        <div class="component-size">
          <span class="option-size-label">尺寸</span>
          <span class="opti-sub-label">w</span>
          <el-input-number
            v-model="componentSizeSet.w"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">h</span>
          <el-input-number
            v-model="componentSizeSet.h"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
      </el-collapse-item>
      <!-- 数据设置 -->
      <el-collapse-item title="数据" name="3">
        <div class="border-config">
          <div class="border-config-item">
            <span class="option-label">筛选维度</span>
            <el-radio-group
              :value="currentComponent.chartSet.chartStyle.filterType"
              @input="handleChangeFilterType">
              <el-radio label="date">时间</el-radio>
              <el-radio label="province">省</el-radio>
              <el-radio label="city">省市</el-radio>
              <el-radio label="region">省市区</el-radio>
            </el-radio-group>
          </div>
          <div class="border-config-item">
            <span class="option-label">隐藏</span>
            <el-switch
              :value="!!currentComponent.chartSet.chartStyle.hideInView"
              @input="(val) => $set(currentComponent.chartSet.chartStyle, 'hideInView', val)" />
          </div>
          <div class="border-config-item">
            <span class="option-label">查看大屏禁用</span>
            <el-switch
              :value="!!currentComponent.chartSet.chartStyle.readOnlyInView"
              @input="(val) => $set(currentComponent.chartSet.chartStyle, 'readOnlyInView', val)" />
          </div>
        </div>
        <div class="border-config" style="margin-top: 12px">
          <div class="border-config-item">
            <span class="option-label">数据来源</span>
            <el-radio-group v-model="currentComponent.chartSet.dataSource" class="data-source-option" @change="handleDataSourceChange">
              <el-radio label="indicatorLib">指标库</el-radio>
              <el-radio label="customize">自定义</el-radio>
            </el-radio-group>
          </div>
          <template v-if="currentComponent.chartSet.dataSource==='indicatorLib'">
            <p class="data-rich-tip" style="margin-top:8px">
              每个筛选组件<strong>仅可选一个指标</strong>；需要多个筛选条件请<strong>添加多个筛选组件</strong>。指标返回<strong>一行</strong>默认筛选值（去掉表头后取首行），须与「筛选维度」一致：<strong>时间</strong>：x 为开始日期、y 为结束日期（yyyy-MM-dd）；<strong>省</strong>：x 或 provinceCode 为省编码；<strong>省市</strong>：x/provinceCode、y/cityCode；<strong>省市区</strong>：x、y、label（或 provinceCode、cityCode、regionCode）为省/市/区编码。修改指标或维度后会自动刷新大屏数据。
            </p>
            <div class="data-indicator">
              <span class="indicator-label">数据指标</span>
              <div class="indicator-content">
                <div class="data-config-item">
                  <el-select
                    :value="filterBlockSingleIndicatorId"
                    filterable
                    clearable
                    style="width:220px;margin-right:0"
                    placeholder="选择指标"
                    @change="onFilterBlockIndicatorSelect">
                    <el-option v-for="(optionItem,idx) in (currentComponent.dataIndicatorList || [])" :key="idx" :value="optionItem.value" :label="optionItem.label"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="data-indicator">
              <span class="indicator-label">指标说明</span>
              <el-switch v-model="currentComponent.chartViewData.showIndicator"></el-switch>
            </div>
          </template>
        </div>
      </el-collapse-item>
      <!-- 组件样式设置 -->
      <el-collapse-item title="样式" name="2">
        <div class="border-config">
          <div class="border-config-item">
            <span class="option-label">背景色</span>
            <el-color-picker
              v-model="currentComponent.chartSet.chartStyle.backgroundColor"
              show-alpha
              :predefine="COLOR_PICKER_LIST">
            </el-color-picker>
          </div>
          <div class="border-config-item">
            <span class="option-label">边框</span>
            <el-color-picker
              v-model="currentComponent.chartSet.chartStyle.borderColor"
              show-alpha
              :predefine="COLOR_PICKER_LIST">
            </el-color-picker>
          </div>

          <div class="border-config-item">
            <span class="option-label">字体</span>
            <el-color-picker
              v-model="currentComponent.chartSet.chartStyle.color"
              :predefine="COLOR_PICKER_LIST" class="style-config-numberColor" />
            <el-input-number
              v-model="currentComponent.chartSet.chartStyle.fontSize"
              :min="8"
              :max="200"
              :step="1"
              controls-position="right"
              style="width: 110px" />
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 【素材-边框】组件配置 -->
    <el-collapse v-else-if="componentType === 'borderBlock'" v-model="activeNames" class="pane-config-container" @keydown.native="handleKeyDown">
      <!-- 组件尺寸设置 -->
      <el-collapse-item title="尺寸" name="1">
        <div class="component-size">
          <span class="option-size-label">位置</span>
          <span class="opti-sub-label">x</span>
          <el-input-number
            v-model="componentSizeSet.x"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">y</span>
          <el-input-number
            v-model="componentSizeSet.y"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
        <div class="component-size">
          <span class="option-size-label">尺寸</span>
          <span class="opti-sub-label">w</span>
          <el-input-number
            v-model="componentSizeSet.w"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">h</span>
          <el-input-number
            v-model="componentSizeSet.h"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
      </el-collapse-item>
      <!-- 组件样式设置 -->
      <el-collapse-item title="样式" name="2">
        <div class="border-config">
          <div class="border-config-item">
            <span class="option-label">背景</span>
            <el-color-picker
              v-model="currentComponent.chartSet.chartStyle.background"
              show-alpha
              :predefine="COLOR_PICKER_LIST">
            </el-color-picker>
          </div>
          <div class="border-config-item">
            <span class="option-label">边框</span>
            <el-input-number
              v-model="currentComponent.chartSet.chartStyle.borderWidth"
              class="border-input"
              :min="0"
              :step="1"
              controls-position="right">
            </el-input-number>
            <el-color-picker
              v-model="currentComponent.chartSet.chartStyle.borderColor"
              show-alpha
              :predefine="COLOR_PICKER_LIST">
            </el-color-picker>
          </div>
          <div class="border-config-item">
            <span class="option-label">边框圆角</span>
            <el-input-number
              v-model="currentComponent.chartSet.chartStyle.borderRadius"
              :min="0"
              :step="1"
              controls-position="right">
            </el-input-number>
          </div>
          <div class="border-config-item">
            <span class="option-label">边角</span>
            <el-switch v-model="currentComponent.chartSet.chartStyle.hasCorner" class="corner-switch" @change="handleChangeHasCorner"></el-switch>
            <el-color-picker
              v-if="currentComponent.chartSet.chartStyle.hasCorner"
              v-model="currentComponent.chartSet.chartStyle.cornerColor"
              show-alpha
              :predefine="COLOR_PICKER_LIST">
            </el-color-picker>
          </div>
          <div v-if="currentComponent.chartSet.chartStyle.hasCorner" class="border-config-item">
            <span class="option-label">边角样式</span>
            <el-select ref="borderSelectType" v-model="currentComponent.chartSet.chartStyle.borderType" style="width: 220px" @change="handleBorderSelectType">
              <el-option v-for="item in BORDER_TYPE_LIST" :key="item.value" :value="item.value" :label="' '">
                <Icon :icon="item.label"></Icon>
              </el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 【素材-署名】组件配置 -->
    <el-collapse v-else-if="componentType === 'signName'" v-model="activeNames" class="pane-config-container" @keydown.native="handleKeyDown">
      <!-- 组件尺寸设置 -->
      <el-collapse-item title="尺寸" name="1">
        <div class="component-size">
          <span class="option-size-label">位置</span>
          <span class="opti-sub-label">x</span>
          <el-input-number
            v-model="componentSizeSet.x"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">y</span>
          <el-input-number
            v-model="componentSizeSet.y"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
        <div class="component-size">
          <span class="option-size-label">尺寸</span>
          <span class="opti-sub-label">w</span>
          <el-input-number
            v-model="componentSizeSet.w"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">h</span>
          <el-input-number
            v-model="componentSizeSet.h"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
      </el-collapse-item>
      <!-- 组件样式设置 -->
      <el-collapse-item title="样式" name="2">
        <div class="sign-name-config">
          <div class="sign-name-config-item">
            <span class="option-label">字体颜色</span>
            <el-color-picker v-model="currentComponent.chartSet.chartStyle.textColor" :predefine="COLOR_PICKER_LIST" class="sign-content" />
          </div>
          <div class="sign-name-config-item">
            <div class="option-label">签名者姓名</div>
            <el-input
              v-model="currentComponent.chartSet.chartStyle.signName" class="sign-content"
              @change="handleChangeSignName">
            </el-input>
          </div>
          <div class="tips">每个签名者拥有专属的签名URL，打开大屏，复制签名URL打开即可进行签名</div>
          <div class="sign-name-config-item">
            <div class="option-label">签名URL</div>
            <div class="sign-content">{{ currentComponent.chartSet.chartStyle.signUrl }}</div>
          </div>
        </div>
      </el-collapse-item>
      <!-- 交互 -->
      <el-collapse-item title="交互" name="7">
        <div class="active-config">
          <span class="option-label">点击跳转</span>
          <el-select ref="selectScreen" v-model="currentComponent.jumpPanelSn" placeholder="选择数据大屏" class="active-config-jump" style="width: 220px; background-color:#fff" clearable>
            <el-option v-for="(item,index) in screenList" :key="index" :value="item.panelSn" :label="formatScreenSelectorLabel(item)"></el-option>
          </el-select>
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 【富文本】组件配置 -->
    <el-collapse v-else-if="componentType === 'richText'" v-model="activeNames" class="pane-config-container" @keydown.native="handleKeyDown">
      <!-- 组件尺寸设置 -->
      <el-collapse-item title="尺寸" name="1">
        <div class="component-size">
          <span class="option-size-label">位置</span>
          <span class="opti-sub-label">x</span>
          <el-input-number
            v-model="componentSizeSet.x"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">y</span>
          <el-input-number
            v-model="componentSizeSet.y"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
        <div class="component-size">
          <span class="option-size-label">尺寸</span>
          <span class="opti-sub-label">w</span>
          <el-input-number
            v-model="componentSizeSet.w"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
          <span class="opti-sub-label">h</span>
          <el-input-number
            v-model="componentSizeSet.h"
            controls-position="right"
            @blur="setComponentSize"
            @change="setComponentSize"
            @keyup.enter.native="setComponentSize">
          </el-input-number>
        </div>
      </el-collapse-item>
      <!-- 组件样式设置（name 勿与「尺寸」重复，否则折叠状态异常） -->
      <el-collapse-item title="字体段落" name="2">
        <div class="title-config">
          <div class="title-config-title">
            <span class="option-label">样式设置</span>
            <ul class="set-font-style">
              <li class="set-font-style-item" @click="handleFontStyle('bold')"> <span style="font-weight: bold;">B</span></li>
              <li class="set-font-style-item" @click="handleFontStyle('italic')"> <span style="font-style: italic;">I</span></li>
              <li class="set-font-style-item" @click="handleFontStyle('underline')"> <span style="text-decoration-line: underline;">U</span></li>
              <li class="set-font-style-item" @click="handleFontStyle('strikeThrough')"> <span style="text-decoration-line: line-through;">S</span></li>
            </ul>
          </div>
          <!--颜色、字体、对齐方式 -->
          <el-color-picker
            v-model="currentComponent.chartSet.titleStyle.color"
            :predefine="COLOR_PICKER_LIST" class="title-config-color" />
          <el-input-number
            v-model="currentComponent.chartSet.titleStyle.fontStyle.fontSize"
            class="title-config-fontsize"
            :min="8"
            :max="300"
            :step="1"
            controls-position="right"
            style="width: 110px" />

          <ul class="set-rich-position">
            <li class="set-rich-position-item" @click="handleJustify('left')"><Icon icon="zu33707" class="1icon"></Icon></li>
            <li class="set-rich-position-item" @click="handleJustify('center')"><Icon icon="zu33708" class="icon"></Icon></li>
            <li class="set-rich-position-item" @click="handleJustify('right')"><Icon icon="zu33709" class="icon"></Icon></li>
          </ul>
          <div class="title-config-title title-config-font-row">
            <span class="option-label">字体</span>
            <ChartFontFamilySelect v-model="titleFontFamilyModel" select-class="title-config-fontfamily" :width="220" />
          </div>

          <div>
          </div>
        </div>
      </el-collapse-item>

      <!-- 交互 -->
      <el-collapse-item title="交互" name="7">
        <div v-if="!['number','independentNumber','gaugeNumber','scrollTable','text','richText','timeClock'].includes(componentType) " class="active-config">
          <span class="option-label">轮播</span>
          <el-switch v-model="currentComponent.chartSet.chartStyle.carousel" :disabled="['mapChart'].includes(componentType)"></el-switch>
          <el-input-number v-model="currentComponent.chartSet.chartStyle.carouselDelay" :min="3" style="margin-left:10px;width:100px;" :step="0.5" controls-position="right"></el-input-number> 秒
        </div>

        <div class="active-config">
          <span class="option-label">点击跳转</span>
          <el-select ref="selectScreen" v-model="currentComponent.jumpPanelSn" placeholder="选择数据大屏" class="active-config-jump" style="width: 220px; background-color:#fff" clearable>
            <el-option v-for="(item,index) in screenList" :key="index" :value="item.panelSn" :label="formatScreenSelectorLabel(item)"></el-option>
          </el-select>
        </div>
      </el-collapse-item>
      <!-- 数据 -->
      <el-collapse-item v-if="!isCompositeScreen" title="数据" name="8">
        <div class="data-config">
          <el-radio-group v-model="currentComponent.chartSet.dataSource" class="data-source-option" @change="handleDataSourceChange">
            <el-radio label="indicatorLib">指标库</el-radio>
            <el-radio label="customize">自定义</el-radio>
          </el-radio-group>
          <template v-if="currentComponent.chartSet.dataSource==='customize'">
            <div class="data-config-title" style="margin-top:10px;">说明</div>
            <p class="data-rich-tip">自定义：双击编辑，支持选区加粗等富文本，与侧栏「字体段落」配合使用。指标库：正文由接口生成纯段落，字号与 B/I/U/S 等仅由侧栏统一控制。</p>
          </template>
          <template v-if="currentComponent.chartSet.dataSource==='indicatorLib'">
            <div class="data-indicator">
              <span class="indicator-label">数据指标</span>
              <div class="indicator-content">
                <div v-for="(item,index) in currentComponent.chartViewData.selectedIndicatorList" :key="(currentComponent.addSn || '') + '-rt-ind-' + index" class="data-config-item">
                  <el-select
                    :value="item.dataIndicator"
                    filterable
                    style="width:220px;margin-right:0"
                    placeholder="选择指标"
                    @change="(val) => normalizeIndicatorValueAtRow(index, val)">
                    <el-option v-for="(optionItem,idx) in (currentComponent.dataIndicatorList || [])" :key="idx" :value="optionItem.value" :label="optionItem.label" :disabled="checkIndexDisable(optionItem, index)"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="data-indicator">
              <span class="indicator-label">指标说明</span>
              <el-switch v-model="currentComponent.chartViewData.showIndicator"></el-switch>
            </div>
          </template>
        </div>
      </el-collapse-item>
    </el-collapse>

    <!-- 【富文本之外】组件 -->
    <el-collapse v-else v-model="activeNames" class="pane-config-container" @keydown.native="handleKeyDown">
      <!-- 【大屏设置】：须与「画布上的组件」区分，不能仅用 chartViews truthy（空数组也会误判） -->
      <div v-if="isScreenSettingsPanel" key="screen">
        <!-- 尺寸-->
        <el-collapse-item title="尺寸" name="1">
          <div class="size-config">
            <el-radio-group v-model="currentComponent.panelProportion" @change="handleScreenSizeChange">
              <el-radio-button label="16:9">16:9</el-radio-button>
              <el-radio-button label="4:3">4:3</el-radio-button>
              <el-radio-button label="custom">自定义</el-radio-button>
            </el-radio-group>
            <el-form ref="screenSizeForm" class="size-width" :model="form" :rules="rules" :inline="true" @submit.native.prevent="handleSubmit">
              <span style="display:inline-block;margin-right: 12px;">
                <el-form-item prop="panelWidth">
                  <span class="size-label">宽</span>
                  <el-input
                    v-model="form.panelWidth"
                    class="size-width-input"
                    :disabled="currentComponent.panelProportion !== 'custom'" />
                </el-form-item>
              </span>
              <el-form-item prop="panelHeight">
                <span>
                  <span class="size-label">高</span>
                  <el-input
                    v-model="form.panelHeight"
                    :disabled="currentComponent.panelProportion !== 'custom'"
                    class="size-width-input" />
                </span>
              </el-form-item>
              <el-button native-type="submit" style="visibility: hidden;"></el-button>
            </el-form>
          </div>
        </el-collapse-item>
        <!-- 颜色 -->
        <el-collapse-item title="颜色" name="3">
          <div class="color-config">
            <span class="option-label"> 组件配色</span>
            <el-select ref="selectColor" v-model="currentComponent.chartColors" placeholder="选择配色方案" class="color-config-select" style="width: 220px" @change="handleThemeColor">
              <el-option v-for="(item,index) in COLOR_LIST" :key="index" :value="item.label" :label="' '">
                <div>
                  <span v-for="(color,ind) in item.value" :key="ind" style="display:inline-block; width:17px;height:17px" :style="{backgroundColor:color}"></span>
                  <span class="color-name" style="display:inline-block; margin-left: 6px;vertical-align: 4px">{{ item.name }}</span>
                </div>
              </el-option>
            </el-select>
            <p class="color-config-hint">作为大屏默认配色；若某组件在「组件设置 → 配色」中选「跟随大屏」，则与该组件同步。</p>
            <div>
              <span class="option-label">背景颜色</span>
              <el-radio-group v-model="currentComponent.backgroundType" class="color-config-bgc" @change="handleBackgroundType">
                <el-radio-button :label="1">纯色</el-radio-button>
                <el-radio-button :label="2">模版</el-radio-button>
                <el-radio-button :label="3">图片</el-radio-button>
              </el-radio-group>
            </div>

            <div v-if="currentComponent.backgroundType === 1" class="background-color">
              <span class="option-label">背景</span>
              <el-color-picker
                v-model="currentComponent.background"
                show-alpha
                :predefine="COLOR_PICKER_LIST"
                class="color-select" />
            </div>
            <div v-if="currentComponent.backgroundType === 2" class="background-template">
              <span class="option-label text">选择模版</span>
              <div class="template-select">
                <el-select ref="selectTemplate" v-model="currentComponent.background" class="template-select-setting" style="display:block; width: 220px;" @change="handleBackground">
                  <el-option v-for="(item,index) in BACKGROUND_TEMPLATE_LIST" :key="index" :value="item" :label="' '">
                    <img :src="item" alt="" style="display:block;width: 180px;height:100px" />
                  </el-option>
                </el-select>
              </div>
            </div>
            <div v-if="currentComponent.backgroundType === 3" class="background-img">
              <span class="option-label">上传图片</span>
              <Single v-model="currentComponent.background" :max-size="form.panelWidth*form.panelHeight"></Single>
            </div>
          </div>
        </el-collapse-item>
        <!-- 交互 -->
        <el-collapse-item title="交互" name="4">
          <div class="active-config">
            <span class="option-label">自动跳转</span>
            <el-select v-model="currentComponent.jumpPanelSn" placeholder="选择数据大屏" class="active-config-jump" style="width: 220px" clearable @clear="handleClearJump">
              <el-option v-for="(item,index) in screenList" :key="index" :value="item.panelSn" :label="formatScreenSelectorLabel(item)"></el-option>
            </el-select>
            <div v-if="currentComponent.jumpPanelSn">
              <span class="option-label">跳转延迟</span>
              <el-input v-model="currentComponent.jumpDelaySecond" class="jump-delay" style="width: 220px"> <span slot="suffix">s</span></el-input>
            </div>
          </div>
        </el-collapse-item>
      </div>

      <!-- 组件设置 -->
      <div v-else key="component">
        <!-- 尺寸 -->
        <el-collapse-item title="尺寸" name="1">
          <div class="component-size">
            <span class="option-size-label">位置</span>
            <span class="opti-sub-label">x</span>
            <el-input-number
              v-model="componentSizeSet.x"
              controls-position="right"
              @blur="setComponentSize"
              @change="setComponentSize"
              @keyup.enter.native="setComponentSize">
            </el-input-number>
            <span class="opti-sub-label">y</span>
            <el-input-number
              v-model="componentSizeSet.y"
              controls-position="right"
              @blur="setComponentSize"
              @change="setComponentSize"
              @keyup.enter.native="setComponentSize">
            </el-input-number>
          </div>
          <div class="component-size">
            <span class="option-size-label">尺寸</span>
            <span class="opti-sub-label">w</span>
            <el-input-number
              v-model="componentSizeSet.w"
              controls-position="right"
              @blur="setComponentSize"
              @change="setComponentSize"
              @keyup.enter.native="setComponentSize">
            </el-input-number>
            <span class="opti-sub-label">h</span>
            <el-input-number
              v-model="componentSizeSet.h"
              controls-position="right"
              @blur="setComponentSize"
              @change="setComponentSize"
              @keyup.enter.native="setComponentSize">
            </el-input-number>
          </div>
        </el-collapse-item>
        <!-- 单组件配色（未设置时跟随大屏 chartColors） -->
        <el-collapse-item v-if="supportsComponentChartTheme" title="配色" name="15">
          <div class="color-config">
            <span class="option-label">组件配色</span>
            <el-select
              v-model="componentChartColorsModel"
              placeholder="选择配色方案"
              class="color-config-select"
              style="width: 220px">
              <el-option label="跟随大屏" value="inherit" />
              <el-option
                v-for="(item,index) in COLOR_LIST"
                :key="'comp-palette-'+index"
                :value="item.label"
                :label="item.name">
                <div>
                  <span
                    v-for="(color,ind) in item.value"
                    :key="ind"
                    style="display:inline-block; width:17px;height:17px"
                    :style="{backgroundColor:color}"></span>
                  <span class="color-name" style="display:inline-block; margin-left: 6px;vertical-align: 4px">{{ item.name }}</span>
                </div>
              </el-option>
            </el-select>
          </div>
        </el-collapse-item>
        <!-- 标题 -->
        <el-collapse-item v-if="componentType !== 'imageBlock' && componentType !== 'timeClock'" title="标题" name="5">
          <div class="title-config">
            <div class="title-config-title">
              <span class="option-label">标题</span>
              <el-input v-model="currentComponent.chartTitle" class="title-label-input" :maxlength="30"></el-input>
            </div>
            <el-color-picker
              v-model="currentComponent.chartSet.titleStyle.color"
              :predefine="COLOR_PICKER_LIST" class="title-config-color" />
            <el-input-number
              v-model="currentComponent.chartSet.titleStyle.fontSize"
              class="title-config-fontsize"
              :min="8"
              :max="200"
              :step="1"
              controls-position="right"
              style="width: 110px" />
            <el-radio-group v-model="currentComponent.chartSet.titleStyle.align" class="set-position">
              <el-radio-button label="left">
                <Icon icon="zu33707" class="1icon"></Icon>
              </el-radio-button>
              <el-radio-button label="center">
                <Icon icon="zu33708" class="icon"></Icon>
              </el-radio-button>
              <el-radio-button label="right">
                <Icon icon="zu33709" class="icon"></Icon>
              </el-radio-button>
            </el-radio-group>
            <div class="title-config-title title-config-font-row">
              <span class="option-label">字体</span>
              <ChartFontFamilySelect v-model="titleFontFamilyModel" select-class="title-config-fontfamily" :width="220" />
            </div>
            <div class="title-config-offset-row">
              <span class="option-label">标题偏移</span>
              <div class="title-offset-controls">
                <span class="title-offset-label">水平</span>
                <el-input-number
                  v-model="currentComponent.chartSet.titleStyle.titleOffsetX"
                  :min="-300"
                  :max="300"
                  :step="1"
                  controls-position="right"
                  class="title-offset-input" />
                <span class="title-offset-label">垂直</span>
                <el-input-number
                  v-model="currentComponent.chartSet.titleStyle.titleOffsetY"
                  :min="-300"
                  :max="300"
                  :step="1"
                  controls-position="right"
                  class="title-offset-input" />
              </div>
            </div>
            <div v-if="!['number','independentNumber','gaugeNumber'].includes(componentType)" class="style-config-border">
              <span class="option-label">标题样式</span>
              <el-radio-group v-model="currentComponent.chartSet.borderStyle.border" @change="handleBorderType">
                <el-radio label="none">无边框</el-radio>
                <el-radio label="template">模版</el-radio>
              </el-radio-group>
              <div v-if="currentComponent.chartSet.borderStyle.border === 'template'" class="set-template">
                <el-select ref="borderTemplate" v-model="currentComponent.chartSet.borderStyle.borderTemplate" class="set-template-select" style="display:block; width: 220px" @change="handleBorder">
                  <el-option v-for="(item,index) in BORDER_TEMPLATE_LIST" :key="index" :value="item" :label="' '">
                    <img :src="item" alt="" style="display:block;width: 200px;" />
                  </el-option>
                </el-select>
                <div class="title-border-stretch-row">
                  <el-switch
                    v-model="borderTemplateStretchModel"
                    class="title-border-stretch-switch"
                    active-text="铺满"
                    inactive-text="原比例" />
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <!-- 样式 -->
        <el-collapse-item v-if="componentType !== 'text' && componentType !== 'imageBlock'" title="样式" name="6">
          <div class="style-config">
            <!-- 组件内文字 -->
            <div v-if="!['text'].includes(componentType)" class="style-config-border">
              <span class="option-label">组件文字</span>
              <el-color-picker
                v-if="['number','independentNumber','gaugeNumber','timeClock','mapChart'].includes(componentType)"
                v-model="currentComponent.chartSet.chartStyle.color"
                :predefine="COLOR_PICKER_LIST" class="style-config-numberColor" />
              <el-input-number
                v-model="currentComponent.chartSet.chartStyle.fontSize"
                :min="8"
                :max="200"
                :step="1"
                controls-position="right"
                style="width: 110px" />
            </div>
            <!-- 当前时间：字体（与标题等共用 ChartFontFamilySelect + chartTitlePresets） -->
            <div v-if="componentType === 'timeClock'" class="style-config-border">
              <span class="option-label">字体</span>
              <ChartFontFamilySelect
                v-model="currentComponent.chartSet.chartStyle.fontFamily"
                select-class="time-clock-font-family"
                :width="220"
                :clearable="true" />
            </div>
            <!-- 当前时间：年月日时分秒片段（:value + $set，避免 Vue2 深层 v-model 不触发视图/画布更新） -->
            <div v-if="componentType === 'timeClock'" class="style-config-border">
              <span class="option-label">显示内容</span>
              <div class="time-display-checkboxes">
                <el-checkbox :value="timeDisplayPartChecked.year" @change="(v) => timeDisplayPartChange('year', v)">年</el-checkbox>
                <el-checkbox :value="timeDisplayPartChecked.month" @change="(v) => timeDisplayPartChange('month', v)">月</el-checkbox>
                <el-checkbox :value="timeDisplayPartChecked.day" @change="(v) => timeDisplayPartChange('day', v)">日</el-checkbox>
                <el-checkbox :value="timeDisplayPartChecked.hour" @change="(v) => timeDisplayPartChange('hour', v)">时</el-checkbox>
                <el-checkbox :value="timeDisplayPartChecked.minute" @change="(v) => timeDisplayPartChange('minute', v)">分</el-checkbox>
                <el-checkbox :value="timeDisplayPartChecked.second" @change="(v) => timeDisplayPartChange('second', v)">秒</el-checkbox>
              </div>
            </div>
            <!-- 纯数字、独立数字 -->
            <div v-if="['independentNumber','gaugeNumber'].includes(componentType)" class="style-config-border">
              <span class="option-label">边框颜色</span>
              <el-color-picker
                v-model="currentComponent.chartSet.borderStyle.color"
                :predefine="COLOR_PICKER_LIST" class="style-config-borderColor" />
            </div>
            <!-- 独立数字 -->
            <div v-if="['independentNumber'].includes(componentType)" class="style-config-border">
              <span class="option-label">边框样式</span>
              <el-select ref="independentNumberSelectType" v-model="currentComponent.chartSet.borderStyle.numberBorderType" style="width: 220px" @change="handleIndependentNumberSelectType">
                <el-option v-for="item in INDEPENDENT_NUMBER_BORDER_LIST" :key="item.value" :value="item.value" :label="' '">
                  <Icon :icon="item.label"></Icon>
                </el-option>
              </el-select>
            </div>

            <!-- 纯数字 -->
            <div v-if="['number'].includes(componentType)" class="style-config-border">
              <span class="option-label">单位</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.hasSymbol"></el-switch>
              <template v-if="currentComponent.chartSet.chartStyle.hasSymbol">
                <el-input v-model="currentComponent.chartSet.chartStyle.symbolText" placeholder="请输入单位" style="width: 140px;" maxlength="5" class="style-config-symbol-input"></el-input>
              </template>
            </div>
            <!-- 纯数字 -->
            <div v-if="['number'].includes(componentType) && currentComponent.chartSet.chartStyle.hasSymbol" class="style-config-border">
              <span class="option-label"></span>
              <el-color-picker
                v-model="currentComponent.chartSet.chartStyle.symbolColor"
                :predefine="COLOR_PICKER_LIST" class="style-config-symbolColor" />
              <el-input-number
                v-model="currentComponent.chartSet.chartStyle.symbolFontSize"
                class="style-config-symbol-font"
                :min="8"
                :max="200"
                :step="1"
                controls-position="right"
                style="width: 110px" />
            </div>
            <!-- 纯数字 -->
            <div v-if="['number'].includes(componentType) && currentComponent.chartSet.chartStyle.hasSymbol" class="style-config-border">
              <span class="option-label">单位位置</span>
              <el-radio-group v-model="currentComponent.chartSet.chartStyle.symbolPosition" @change="handleBorderType">
                <el-radio label="left">左</el-radio>
                <el-radio label="right">右</el-radio>
              </el-radio-group>
            </div>

            <!-- 地图 -->
            <div v-if="['mapChart'].includes(componentType) " class="style-config-border">
              <span class="option-label">行政区划</span>
              <el-cascader
                v-model="currentComponent.chartSet.chartStyle.map"
                style="width: 220px; "
                :options="mapChartChooseList"
                :show-all-levels="false"
                :props="{ checkStrictly: true,value:'code',label:'name' }"
                @change="handleMapSourceChange" />
            </div>
            <div v-if="['mapChart'].includes(componentType)" class="style-config-border">
              <span class="option-label">数值热力</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.heatByValue" />
            </div>
            <template v-if="['mapChart'].includes(componentType) && currentComponent.chartSet.chartStyle.heatByValue">
              <div class="style-config-border">
                <span class="option-label">分段图例</span>
                <el-switch v-model="currentComponent.chartSet.chartStyle.hasVisualMap" @change="mapOnVisualMapSwitch" />
              </div>
              <template v-if="currentComponent.chartSet.chartStyle.hasVisualMap">
                <div class="style-config-border map-visual-map-title-row">
                  <span class="option-label">图例标题</span>
                  <el-input v-model="mapVisualMapTitleModel" placeholder="如：零售额（亿美元）" style="width: 220px" clearable />
                </div>
                <div class="style-config-border map-visual-pieces-head">
                  <span class="option-label">数值分段</span>
                  <el-button type="text" size="small" @click="mapAddVisualPieceRow">添加区间</el-button>
                </div>
                <div
                  v-for="(row, idx) in mapVisualPiecesForEdit"
                  :key="'vm-piece-' + idx"
                  class="style-config-border map-visual-piece-row">
                  <el-input v-model="row.min" placeholder="≥min" class="map-vm-inp" clearable />
                  <el-input v-model="row.max" placeholder="≤max" class="map-vm-inp" clearable />
                  <el-input v-model="row.label" placeholder="图例文案" class="map-vm-label" clearable />
                  <el-color-picker v-model="row.color" :predefine="COLOR_PICKER_LIST" show-alpha class="map-vm-color" />
                  <Icon
                    v-show="mapVisualPiecesForEdit.length > 1"
                    icon="zu34064"
                    class="map-vm-del"
                    @click.native="mapRemoveVisualPieceRow(idx)" />
                </div>
                <p class="map-visual-hint">每行至少填 min 或 max 之一（可只填 min 表示「以上」、只填 max 表示「以下」），并选择颜色；至少保留一行区间；未配置有效分段时仍用渐变热力。</p>
              </template>
            </template>
            <!-- 地图 -->
            <div v-if="['mapChart','heatMapChart'].includes(componentType)" class="style-config-border">
              <span class="option-label">缩放比例</span>
              <el-input-number v-model="currentComponent.chartSet.chartStyle.zoom" show-input :max="10" :step="0.1" controls-position="right"> </el-input-number>
            </div>
            <div v-if="['mapChart'].includes(componentType)" class="style-config-border">
              <span class="option-label">轮播高亮色</span>
              <el-color-picker
                v-model="currentComponent.chartSet.chartStyle.carouselHighlightColor"
                show-alpha
                :predefine="COLOR_PICKER_LIST" />
            </div>
            <template v-if="['mapChart'].includes(componentType)">
              <p class="map-visual-hint" style="margin-top: 4px;">以下为经纬度航线图层（指标含「起点经纬度 / 落点经纬度」并连线时显示）。</p>
              <div class="style-config-border">
                <span class="option-label">航线粗细</span>
                <el-input-number
                  v-model="currentComponent.chartSet.chartStyle.mapRouteLineWidth"
                  :min="0.5"
                  :max="16"
                  :step="0.1"
                  controls-position="right"
                  style="width: 130px" />
              </div>
              <div class="style-config-border">
                <span class="option-label">尾迹长度</span>
                <el-slider
                  v-model="currentComponent.chartSet.chartStyle.mapRouteTrailLength"
                  :min="0"
                  :max="1"
                  :step="0.05"
                  show-input />
              </div>
              <div class="style-config-border">
                <span class="option-label">航线颜色</span>
                <el-color-picker
                  v-model="currentComponent.chartSet.chartStyle.mapRouteLineColor"
                  show-alpha
                  :predefine="COLOR_PICKER_LIST" />
              </div>
              <div class="style-config-border">
                <span class="option-label">箭头尺寸</span>
                <el-input-number
                  v-model="currentComponent.chartSet.chartStyle.mapRouteEffectSymbolSizeW"
                  :min="1"
                  :max="48"
                  :step="1"
                  controls-position="right"
                  style="width: 88px" />
                <span style="margin: 0 6px">×</span>
                <el-input-number
                  v-model="currentComponent.chartSet.chartStyle.mapRouteEffectSymbolSizeH"
                  :min="1"
                  :max="48"
                  :step="1"
                  controls-position="right"
                  style="width: 88px" />
              </div>
              <div class="style-config-border">
                <span class="option-label">飞线速度</span>
                <el-input-number
                  v-model="currentComponent.chartSet.chartStyle.mapRouteConstantSpeed"
                  :min="4"
                  :max="400"
                  :step="4"
                  controls-position="right"
                  style="width: 130px" />
                <span style="margin-left: 8px; color: #909399; font-size: 12px">像素/秒</span>
              </div>
              <div class="style-config-border">
                <span class="option-label">落点标记</span>
                <el-input-number
                  v-model="currentComponent.chartSet.chartStyle.mapRouteScatterSymbolSize"
                  :min="4"
                  :max="80"
                  :step="1"
                  controls-position="right"
                  style="width: 130px" />
              </div>
            </template>
            <!-- 热力图（实际是散点图） -->
            <div v-if="['heatMapChart'].includes(componentType)" class="style-config-border">
              <span class="option-label">地图样式</span>
              <el-select v-model="currentComponent.chartSet.chartStyle.mapStyle" style="width: 130px">
                <el-option v-for="item in AMAP_STYLE_LIST" :key="item.value" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </div>
            <!-- 热力图（实际是散点图） -->
            <div v-if="['heatMapChart'].includes(componentType) " class="style-config-border">
              <span class="option-label">高亮</span>
              <el-input-number v-model="currentComponent.chartSet.chartStyle.highlightCount" :min="0" style="width:130px;" :step="1" controls-position="right"></el-input-number>
            </div>
            <!-- 热力图（实际是散点图） -->
            <div v-if="['heatMapChart'].includes(componentType) " class="style-config-border">
              <span class="option-label">中心经度</span>
              <el-input-number v-model="currentComponent.chartSet.chartStyle.lng" :min="0" style="width:130px;" :step="1" controls-position="right"></el-input-number>
            </div>
            <!-- 热力图（实际是散点图） -->
            <div v-if="['heatMapChart'].includes(componentType) " class="style-config-border">
              <span class="option-label">中心纬度</span>
              <el-input-number v-model="currentComponent.chartSet.chartStyle.lat" :min="0" style="width:130px;" :step="1" controls-position="right"></el-input-number>
            </div>

            <!-- 纯数字 独立数字 仪表板 滚动列表 之外 -->
            <div v-if="!['number','independentNumber','gaugeNumber','scrollTable','rank'].includes(componentType)" class="style-config-border">
              <span class="option-label">标签</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.isLabel"></el-switch>
            </div>
            <div
              v-if="componentType === 'mapChart' && currentComponent.chartSet.chartStyle.isLabel"
              class="style-config-border">
              <span class="option-label">仅有数据展示标签</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.mapLabelOnlyWhenHasValue"></el-switch>
            </div>
            <!-- 饼图 环形图 -->
            <div v-if="['pie','pieCircular'].includes(componentType) && currentComponent.chartSet.chartStyle.isLabel" class="style-config-border">
              <span class="option-label">标签内容</span>
              <el-radio-group v-model="currentComponent.chartSet.chartStyle.labelContent">
                <el-radio label="number">数据</el-radio>
                <el-radio label="percent">占比</el-radio>
              </el-radio-group>
            </div>
            <div v-if="['pie','pieCircular'].includes(componentType) && currentComponent.chartSet.chartStyle.isLabel" class="style-config-border">
              <span class="option-label">Top N 标签</span>
              <el-input-number
                v-model="currentComponent.chartSet.chartStyle.pieLabelTopN"
                :min="0"
                :max="50"
                :step="1"
                controls-position="right"
                style="width: 110px" />
              <span style="margin-left:8px;font-size:12px;color:#909399">按数值前 N 项；0 为关闭</span>
            </div>
            <div
              v-if="['pie','pieCircular'].includes(componentType) && currentComponent.chartSet.chartStyle.isLabel && currentComponent.chartSet.chartStyle.pieLabelTopN > 0"
              class="style-config-border pie-topn-style-inline">
              <span class="option-label">Top N 样式</span>
              <div class="pie-topn-style-controls">
                <el-color-picker
                  v-model="currentComponent.chartSet.chartStyle.pieTopNLabelColor"
                  show-alpha
                  :predefine="COLOR_PICKER_LIST" />
                <el-input-number
                  v-model="currentComponent.chartSet.chartStyle.pieTopNLabelFontSize"
                  :min="8"
                  :max="200"
                  :step="1"
                  controls-position="right"
                  style="width: 110px" />
                <el-switch v-model="currentComponent.chartSet.chartStyle.pieTopNLabelBold" />
                <span class="pie-topn-style-hint"></span>
              </div>
            </div>
            <!-- 饼图 环形图 -->
            <div v-if="['pie','pieCircular','verticalBar','line','areaLine','lineBarMix'].includes(componentType)" class="style-config-border">
              <span class="option-label">图例展示</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.isLegend"></el-switch>
              <el-radio-group
                v-if="['pie','pieCircular'].includes(componentType) && currentComponent.chartSet.chartStyle.isLegend"
                v-model="currentComponent.chartSet.chartStyle.legendPosition" style="margin-left: 10px">
                <el-radio label="top">上方</el-radio>
                <el-radio label="right">右侧</el-radio>
              </el-radio-group>
            </div>

            <!-- 支持图例展示时设置 图例文字的大小 -->
            <div v-if="currentComponent.chartSet.chartStyle.isLegend" class="style-config-border">
              <span class="option-label">图例文字</span>
              <el-input-number
                v-model="currentComponent.chartSet.chartStyle.legendSize"
                :min="8"
                :max="200"
                :step="1"
                controls-position="right"
                style="width: 110px" />
            </div>

            <!-- 面积图 折线图 -->
            <div v-if="['areaLine','line','lineBarMix'].includes(componentType)" class="style-config-border">
              <span class="option-label">平滑曲线</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.smooth"></el-switch>
            </div>

            <!-- 面积图：填充自上而下渐隐 -->
            <div v-if="['areaLine'].includes(componentType)" class="style-config-border">
              <span class="option-label">渐变</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.areaGradientFade"></el-switch>
            </div>

            <!-- 折线图、面积图 -->
            <div v-if="['line','areaLine','lineBarMix'].includes(componentType)" class="style-config-border">
              <span class="option-label">支持双轴</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.doubleAxis"></el-switch>
            </div>

            <!-- 折线 / 面积 / 纵向柱 / 折柱混合：X 轴类目标签旋转（缓解密集省略） -->
            <div v-if="['line','areaLine','verticalBar','lineBarMix'].includes(componentType)" class="style-config-border">
              <span class="option-label">X轴标签旋转</span>
              <el-input-number
                :value="xAxisLabelRotatePaneValue"
                :min="-90"
                :max="90"
                :step="1"
                controls-position="right"
                style="width: 110px"
                @change="setXAxisLabelRotate" />
              <span style="margin-left:8px;font-size:12px;color:#909399">度；0 为水平</span>
            </div>
            <div v-if="['line','areaLine','verticalBar','lineBarMix'].includes(componentType)" class="style-config-border">
              <span class="option-label">旋转时底部留白</span>
              <el-input-number
                v-model="xAxisLabelRotateBottomPercentModel"
                :min="5"
                :max="80"
                :step="1"
                controls-position="right"
                style="width: 110px" />
              <span style="margin-left:8px;font-size:12px;color:#909399">%；仅在有旋转时作用于图表底部间距</span>
            </div>

            <!-- 折柱混合：按列选择折线 / 柱状 -->
            <template v-if="componentType === 'lineBarMix'">
              <p class="data-rich-tip" style="margin:10px 0 4px">系列类型（按数据列）</p>
              <div
                v-for="colKey in mixLineBarValueColKeys"
                :key="'mix-st-' + colKey"
                class="border-config-item">
                <span class="option-label">{{ (currentTableHeader || {})[colKey] || colKey }}</span>
                <el-select
                  :value="mixSeriesTypeColMap[colKey] || 'line'"
                  style="width:120px"
                  @change="(v) => setMixSeriesTypeCol(colKey, v)">
                  <el-option label="折线" value="line" />
                  <el-option label="柱状" value="bar" />
                </el-select>
              </div>
            </template>

            <!--  仪表板 -->
            <div v-if="['gaugeNumber'].includes(componentType)" class="style-config-border">
              <span class="option-label">轴标签</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.axisLabel"></el-switch>
            </div>

            <!-- 横向、纵向柱状图 -->
            <div v-if="['horizonBar','verticalBar','rank','lineBarMix'].includes(componentType)" class="style-config-border">
              <span class="option-label">柱形宽度</span>
              <el-slider v-model="currentComponent.chartSet.chartStyle.borderWidth" show-input> </el-slider>
            </div>
            <!-- 横向、纵向柱状图、榜单图 -->
            <div v-if="['horizonBar','verticalBar','rank','lineBarMix'].includes(componentType)" class="style-config-border">
              <span class="option-label">柱形圆角</span>
              <el-slider v-model="currentComponent.chartSet.chartStyle.borderRadius" show-input> </el-slider>
            </div>

            <!-- 仪表板 极坐标 排行榜 -->
            <div v-if="['gaugeNumber','barPolar','rank'].includes(componentType)" class="style-config-border">
              <span class="option-label">最大值</span>
              <el-input v-model="theMax" placeholder="请输入" style="width: 117px" @blur="handleChangeMax" @keyup.enter.native="handleChangeMax" @keyup.native="theMax = theMax.replace(/[^\d]/g,'')"></el-input>
            </div>

            <!-- 排行榜 -->
            <div v-if=" ['rank'].includes(componentType)" class="style-config-border">
              <span class="option-label">榜单个数</span>
              <el-input v-model="currentComponent.chartSet.chartStyle.setRankNumber" :max="5" placeholder="请输入" style="width: 117px"></el-input>
            </div>

            <!-- 排行榜 Y 轴名称样式 -->
            <div v-if="componentType === 'rank'" class="style-config-border">
              <span class="option-label">Y轴名称颜色</span>
              <el-color-picker
                v-model="currentComponent.chartSet.chartStyle.rankYAxisLabelColor"
                show-alpha
                :predefine="COLOR_PICKER_LIST" />
            </div>
            <div v-if="componentType === 'rank'" class="style-config-border">
              <span class="option-label">Top N 标签</span>
              <el-input-number
                v-model="currentComponent.chartSet.chartStyle.rankLabelTopN"
                :min="0"
                :max="50"
                :step="1"
                controls-position="right"
                style="width: 110px" />
              <span style="margin-left:8px;font-size:12px;color:#909399">按排名位置前 N 项；0 为关闭</span>
            </div>
            <div
              v-if="componentType === 'rank' && currentComponent.chartSet.chartStyle.rankLabelTopN > 0"
              class="style-config-border pie-topn-style-inline">
              <span class="option-label">Top N 样式</span>
              <div class="pie-topn-style-controls">
                <el-color-picker
                  v-model="currentComponent.chartSet.chartStyle.rankTopNLabelColor"
                  show-alpha
                  :predefine="COLOR_PICKER_LIST" />
                <el-input-number
                  v-model="currentComponent.chartSet.chartStyle.rankTopNLabelFontSize"
                  :min="8"
                  :max="200"
                  :step="1"
                  controls-position="right"
                  style="width: 110px" />
                <el-switch v-model="currentComponent.chartSet.chartStyle.rankTopNLabelBold" />
              </div>
            </div>

            <!-- 仪表板 排行榜 -->
            <div v-if=" ['gaugeNumber','rank'].includes(componentType)" class="style-config-border">
              <span class="option-label">单位</span>
              <el-input v-model="currentComponent.chartSet.chartStyle.unit" :max="5" placeholder="请输入" style="width: 117px"></el-input>
            </div>

            <!-- 饼图 -->
            <div v-if="['pie'].includes(componentType)" class="style-config-border">
              <span class="option-label">半径大小</span>
              <el-slider v-model="currentComponent.chartSet.chartStyle.radius" show-input> </el-slider>
            </div>
            <!-- 极坐标 环形图 -->
            <div v-if="['barPolar','pieCircular'].includes(componentType)" class="style-config-border">
              <span class="option-label">内径大小</span>
              <el-slider v-model="currentComponent.chartSet.chartStyle.internalRadius" show-input> </el-slider>
            </div>
            <!-- 极坐标 环形图 -->
            <div v-if="['barPolar','pieCircular'].includes(componentType) " class="style-config-border">
              <span class="option-label">外径大小</span>
              <el-slider v-model="currentComponent.chartSet.chartStyle.externalRadius" show-input> </el-slider>
            </div>

            <!-- 饼图、环形图：扇区倒角、扇区间距 -->
            <div v-if="['pie','pieCircular'].includes(componentType)" class="style-config-border">
              <span class="option-label">倒角</span>
              <el-slider v-model="currentComponent.chartSet.chartStyle.sliceBorderRadius" :min="0" :max="40" show-input />
            </div>
            <div v-if="['pie','pieCircular'].includes(componentType)" class="style-config-border">
              <span class="option-label">黑色填充</span>
              <el-slider v-model="currentComponent.chartSet.chartStyle.sliceBlackFill" :min="0" :max="12" show-input />
            </div>

            <!-- 饼图、环形图、排行榜 -->
            <div v-if="['pie','pieCircular','rank',].includes(componentType)" class="style-config-border">
              <span class="option-label">比率显示</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.setRate" @change="handleRankRate"></el-switch>

              <el-radio-group
                v-if="['rank'].includes(componentType) && currentComponent.chartSet.chartStyle.setRate"
                v-model="currentComponent.chartSet.chartStyle.rateType" style="margin-left: 10px">
                <el-radio label="yearRate">同比</el-radio>
                <el-radio label="quarterRate">环比</el-radio>
              </el-radio-group>
              <el-color-picker
                v-if="['rank'].includes(componentType) && currentComponent.chartSet.chartStyle.setRate "
                v-model="currentComponent.chartSet.chartStyle.rateColor"
                :predefine="COLOR_PICKER_LIST" class="style-config-rateColor" />
            </div>
            <!-- 滚动列表 -->
            <div v-if="componentType ==='scrollTable'" class="style-config-border">
              <span class="option-label">斑马纹</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.stripe"></el-switch>
            </div>

            <!-- 滚动列表 折线图 -->
            <div v-if="['scrollTable','line'].includes(componentType)" class="style-config-border">
              <span class="option-label">关联地图</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.isLinkMap" @change="handleLinkMapSwitch" />
              <el-select
                v-if="currentComponent.chartSet.chartStyle.isLinkMap"
                v-model="currentComponent.chartSet.chartStyle.linkMap"
                placeholder="请选择地图组件"
                class="link-map-select"
                @change="handleLinkMapChange">
                <el-option
                  v-for="(item,i) in mapComponentList"
                  :key="i"
                  :label="item.chartTitle || '未命名地图组件'"
                  :value="item.addSn" />
              </el-select>
            </div>
          </div>
        </el-collapse-item>
        <!-- 交互 -->
        <el-collapse-item title="交互" name="7">
          <div v-if="!['number','independentNumber','gaugeNumber','scrollTable','text','timeClock'].includes(componentType) " class="active-config">
            <span class="option-label">轮播</span>
            <el-switch v-model="currentComponent.chartSet.chartStyle.carousel" :disabled="['mapChart'].includes(componentType)"></el-switch>
            <el-input-number v-model="currentComponent.chartSet.chartStyle.carouselDelay" :min="3" style="margin-left:10px;width:100px;" :step="0.5" controls-position="right"></el-input-number> 秒
          </div>

          <div v-if="componentType === 'scrollTable'" class="active-config">
            <span class="option-label">是否滚动</span>
            <el-switch v-model="currentComponent.chartSet.chartStyle.isScroll"></el-switch>
          </div>
          <template v-if="currentComponent.chartSet.chartStyle.isScroll">
            <div v-if="componentType === 'scrollTable'" class="active-config">
              <span class="option-label">鼠标悬停</span>
              <el-switch v-model="currentComponent.chartSet.chartStyle.hoverStop"></el-switch>
            </div>

            <div v-if="componentType === 'scrollTable'" class="active-config">
              <span class="option-label">滚动速度</span>
              <el-input-number v-model="currentComponent.chartSet.chartStyle.step" :step="0.1" controls-position="right"></el-input-number>
            </div>
          </template>
          <div class="active-config">
            <span class="option-label">点击跳转</span>
            <el-select ref="selectScreen" v-model="currentComponent.jumpPanelSn" placeholder="选择数据大屏" class="active-config-jump" style="width: 220px; background-color:#fff" clearable>
              <el-option v-for="(item,index) in screenList" :key="index" :value="item.panelSn" :label="formatScreenSelectorLabel(item)"></el-option>
            </el-select>
          </div>
        </el-collapse-item>
        <!-- 数据 -->
        <el-collapse-item
          v-if="componentType !== 'text' && componentType !== 'timeClock' && (!isCompositeScreen || componentType === 'imageBlock')"
          title="数据"
          name="8">
          <div class="data-config">
            <div v-if="needUpdateMapRelate" class="map-change-tips">
              <i class="el-icon-warning" /><span>关联地图组件的行政区划已调整，点击“更新”获取新的行政区划，系统将自动清空原行政区划的数据，更新后录入新数据。</span>
            </div>
            <div v-if="componentType === 'mapChart' && currentComponent.chartSet.chartStyle.mapChangeTip" class="map-change-tips">
              <i class="el-icon-warning" /><span>行政区划已调整，请更新组件数据。</span>
            </div>
            <el-radio-group
              v-if="!(isCompositeScreen && componentType === 'imageBlock')"
              v-model="currentComponent.chartSet.dataSource"
              class="data-source-option"
              @change="handleDataSourceChange">
              <el-radio label="indicatorLib">指标库</el-radio>
              <el-radio label="customize">自定义</el-radio>
            </el-radio-group>
            <template v-if="currentComponent.chartSet.dataSource==='customize'">
              <!-- 图片组件：自定义来源仅 OSS 上传，不再使用表格与管理数据弹窗 -->
              <template v-if="componentType === 'imageBlock'">
                <div class="border-config-item" style="margin-top:12px">
                  <span class="option-label">图片</span>
                  <Single
                    v-model="imageBlockPictureUrlModel"
                    box-width="220"
                    box-height="140"
                    :max-size="10 * 1024 * 1024" />
                </div>
                <p class="data-rich-tip" style="margin-top:8px">支持常见图片格式（如 jpg、png、webp、gif、svg 等），将上传至 OSS；删除图片可清空地址。</p>
              </template>
              <template v-else>
                <div :style="{matginTop:'10px'}">
                  <el-button type="primary" @click="handleManageData">管理数据</el-button>
                  <el-button v-if="needUpdateMapRelate" type="primary" plain @click="handleUpdateMapData">更新</el-button>
                </div>
                <div class="data-config-title">数据预览</div>
                <!-- 单数据源 -->
                <template v-if="!isMultipleChartData">
                  <el-table
                    :key="uniqueKey"
                    v-loading="currentComponent.chartViewData.initDataFlag"
                    element-loading-text="初始数据请重置"
                    element-loading-spinner=" "
                    element-loading-background="rgba(0, 0, 0, .3)"
                    class="manage-table"
                    stripe
                    border
                    :max-height="200"
                    :show-header="true"
                    :data="currentTableData">
                    <el-table-column
                      v-for="(key,i) in Object.keys(currentTableHeader)"
                      :key="i"
                      :prop="key">
                      <template #header>
                        <!-- 表头 -->
                        <span class="cell-content">{{ currentTableHeader[key] }}
                          <span v-if="currentComponent.chartSet.chartStyle.doubleAxis && key !=='col_0'" class="axis-label">
                            {{ currentComponent.chartSet.chartStyle.axisConfig && currentComponent.chartSet.chartStyle.axisConfig[key] ? 'y2':'y1' }}
                          </span>
                        </span>
                      </template>
                      <!-- Cell -->
                      <template slot-scope="scope">
                        <span class="cell-content">{{ scope.row[key] }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
                <!-- 多数据源 -->
                <template v-else>
                  <el-tabs tab-position="left">
                    <el-tab-pane v-for="(item,i) in currentComponent.chartViewData.chartData" :key="i" :label="item.labelName">
                      {{ item.labelName }}
                      <el-table
                        :key="uniqueKey+'_'+i"
                        v-loading="currentComponent.chartViewData.initDataFlag"
                        element-loading-text="初始数据请重置"
                        element-loading-spinner=" "
                        element-loading-background="rgba(0, 0, 0, .3)"
                        class="manage-table"
                        stripe
                        border
                        :max-height="200"
                        :show-header="true"
                        :data="getCurTableData(item.realChartData)">
                        <el-table-column
                          v-for="(key,idx) in Object.keys(item.realChartData[0])"
                          :key="idx"
                          :prop="key">
                          <template #header>
                            <!-- 表头 -->
                            <span class="cell-content">{{ item.realChartData[0][key] }}
                              <span v-if="currentComponent.chartSet.chartStyle.doubleAxis && key !=='col_0'" class="axis-label">
                                {{ item.setAxis && item.setAxis[key] ? 'y2':'y1' }}
                              </span>
                            </span>
                          </template>
                          <!-- Cell -->
                          <template slot-scope="scope">
                            <span class="cell-content">{{ scope.row[key] }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-tab-pane>
                  </el-tabs>
                </template>
              </template>
            </template>
            <template v-if="currentComponent.chartSet.dataSource==='indicatorLib'">
              <div class="data-indicator">
                <span class="indicator-label">数据指标</span>
                <div class="indicator-content">
                  <div v-for="(item,index) in currentComponent.chartViewData.selectedIndicatorList" :key="(currentComponent.addSn || '') + '-ind-' + index" class="data-config-item">
                    <el-select
                      :value="item.dataIndicator"
                      filterable
                      :style="{'width': index===0?'220px':'160px' ,'margin-right': index===0? '0px':'5px' }"
                      placeholder="选择指标"
                      @change="(val) => normalizeIndicatorValueAtRow(index, val)">
                      <el-option v-for="(optionItem,idx) in (currentComponent.dataIndicatorList || [])" :key="idx" :value="optionItem.value" :label="optionItem.label" :disabled="checkIndexDisable(optionItem, index)"></el-option>
                    </el-select>
                    <!-- 折线图/面积图双轴模式下，为每个指标显示轴选择器 -->
                    <el-select
                      v-if="['line','areaLine','lineBarMix'].includes(componentType) && currentComponent.chartSet.chartStyle.doubleAxis"
                      :value="getIndicatorAxisIndex(index)"
                      class="indicator-axis-select"
                      placeholder="y轴"
                      @change="(val) => setIndicatorAxisIndex(index, val)">
                      <el-option :value="0" label="y1">y1</el-option>
                      <el-option :value="1" label="y2">y2</el-option>
                    </el-select>
                    <Icon v-if="index> 0 " icon="zu34064" class="data-config-del" @click.native="handleDelIndicator(index)"></Icon>
                  </div>
                </div>
              </div>
              <div class="data-indicator indicatior-icon">
                <Icon v-if="['line','areaLine','lineBarMix','verticalBar','mapChart'].includes(componentType) " icon="zu34063" class="data-config-add" @click.native="handleAddIndicator"></Icon>
              </div>
              <div class="data-indicator">
                <span class="indicator-label">指标说明</span>
                <el-switch v-model="currentComponent.chartViewData.showIndicator"></el-switch>
              </div>
            </template>
          </div>
        </el-collapse-item>
      </div>
    </el-collapse>

    <!-- 编辑数据弹窗 -->
    <ManageDataDialog
      v-if="dialogVisible"
      :raw-data="currentComponent.chartViewData.chartData"
      :is-multiple-chart-data="isMultipleChartData"
      :init-data-flag="currentComponent.chartViewData.initDataFlag"
      :double-axis-flag="currentComponent.chartSet.chartStyle.doubleAxis || false"
      :axis-config="currentComponent.chartSet.chartStyle.axisConfig || {}"
      @confirm="handleDataConfirm"
      @close="dialogVisible = false" />
  </div>
</template>

<script>
import {
  BACKGROUND_TEMPLATE_LIST,
  BORDER_TEMPLATE_LIST,
} from '../data'
import _ from 'lodash'
import {
  COLOR_LIST,
  COLOR_PICKER_LIST,
  INDEPENDENT_NUMBER_BORDER_LIST,
  BORDER_TYPE_LIST,
  AMAP_STYLE_LIST,
} from '@/utils/defaultColorData'
import ManageDataDialog from './manageDataDialog.vue'
import {
  TABLE_HEADER,
  TABLE_ROW,
  componentInitDataMap,
  INIT_IMAGE_BLOCK_CHART_DATA,
} from '@/utils/defaultComponentConfig'
import {
  getScreenListApi,
  saveComponentDataApi,
  getDataIndicatorApi,
} from '../fetch'
import Single from '../../../components/imageUpload/single.vue'
import { needIndexComponent, indicatorChartTypeForApi } from '../funcs'
import { mapGetters } from 'vuex'
import { alignSelectedIndicatorsWithOptionValues } from '@/utils/indicatorSelect'
import { getActiveTabId, setActiveTabId } from '@/utils/compositeTabState'
import {
  mergeCompositeTabBarBarStyle,
  COMPOSITE_TAB_BAR_ACTIVE_TEMPLATE_URL,
  validateCompositeTabOneLevelNesting,
  normalizeCompositeTabUrlInset,
  COMPOSITE_TAB_URL_INSET_DEFAULTS,
} from '@/utils/compositeScreen'
import { randomString } from '@/utils/common'
import { isRichFontStyleFlagOn } from '@/utils/richTextTypography'
const MULTIPLE_DATA_INIT = [
  { col_0: '列1', col_1: '列2', col_2: '列3', col_3: '列4', col_4: '列5', col_5: '列6', col_6: '列7', col_7: '列8' },
  { col_0: '', col_1: '', col_2: '', col_3: '', col_4: '', col_5: '', col_6: '', col_7: '' },
]

/** 支持「组件内单独配色」的图表类组件（其余类型不展示配色折叠项） */
const CHART_THEME_COMPONENT_TYPES = [
  'pie', 'pieCircular', 'line', 'areaLine', 'lineBarMix', 'verticalBar', 'horizonBar', 'barPolar',
  'mapChart', 'heatMapChart', 'rank', 'scrollTable', 'number', 'independentNumber', 'gaugeNumber',
]

export default {
  name: 'PaneConfig',
  components: {
    ManageDataDialog,
    Single,
  },
  props: {
    relateMap: {
      type: Object,
    },
    currentComponent: {
      type: Object,
    },
    mapComponentList: {
      type: Array,
    },
    screenConfig: {
      type: Object,
    },
    screenData: {
      type: Array,
    },
    /** normal | composite */
    panelType: {
      type: String,
      default: 'normal',
    },
    /** 编辑页：当前选中为整屏根对象（与 screenConfig 同一引用），用于稳定展示「大屏设置」 */
    isScreenRootSelected: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    const validateSize = (rule, value, callback) => {
      const { field } = rule
      if (value > 5000) {
        this.form[field] = 5000
      } else if (value < 100) {
        this.form[field] = 100
      }
      this.currentComponent[field] = this.form[field]
      callback()
    }
    // 默认的指标
    const indicator = { dataIndicator: '' }
    return {
      screenSelectorOptions: [],
      initIndicator: _.cloneDeep(indicator),
      // 高德地图样式
      AMAP_STYLE_LIST,
      componentSizeSet: {
        w: '',
        h: '',
        x: '',
        y: '',
      },
      chartDataBak: null,
      uniqueKey: 8090,
      dialogVisible: false,
      activeNames: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
      COLOR_LIST,

      // color-picker 预定义颜色
      COLOR_PICKER_LIST,

      // 独立数字组件边框样式下拉
      INDEPENDENT_NUMBER_BORDER_LIST,

      // 边框组件边框样式
      BORDER_TYPE_LIST,

      //  大屏背景模板
      BACKGROUND_TEMPLATE_LIST,

      //  组件边框模板
      BORDER_TEMPLATE_LIST,
      form: {
        panelWidth: 1920,
        panelHeight: 1080,
      },
      rules: {
        panelWidth: [
          { required: false, validator: validateSize, trigger: 'blur' },
        ],
        panelHeight: [
          { required: false, validator: validateSize, trigger: 'blur' },
        ],
      },
      theMax: 100,
      screenList: [],
      screenId: this.$route.params.id, // 大屏id
      initChartData: [],
      needSyncCache: {},
      needUpdateMapRelate: false,
      /** 模板图地址（仅一项，供模板预览 img） */
      COMPOSITE_TAB_BAR_ACTIVE_TEMPLATE_URL,
    }
  },
  computed: {
    ...mapGetters(['regionInfo']),
    /** 大屏根对象：优先用编辑页引用相等判断，避免接口根对象误带 chartComponent 时无法编辑尺寸/背景 */
    isScreenSettingsPanel () {
      if (this.isScreenRootSelected) return true
      const c = this.currentComponent
      return !!(c && Array.isArray(c.chartViews) && (c.chartComponent === undefined || c.chartComponent === null || c.chartComponent === ''))
    },
    isCompositeScreen () {
      return this.panelType === 'composite'
    },
    mapChartChooseList () {
      return ([{ code: '100000', name: '全国', children: [...this.regionInfo] }, { code: 'world.zh', name: '全球' }])
    },
    /** 筛选组件仅单行指标：供 el-select :value 绑定 */
    filterBlockSingleIndicatorId () {
      const row = this.currentComponent?.chartViewData?.selectedIndicatorList?.[0]
      return row?.dataIndicator != null && row.dataIndicator !== '' ? row.dataIndicator : undefined
    },
    currentTableHeader () {
      return this.currentChartData?.length ? this.currentChartData[0] : []
    },
    /** 折柱混合图：除首列外的数据列 key（与 seriesTypeByCol 对齐） */
    mixLineBarValueColKeys () {
      if (this.componentType !== 'lineBarMix') return []
      const h = this.currentTableHeader
      if (!h || typeof h !== 'object') return []
      return Object.keys(h).slice(1)
    },
    /** 折柱混合：列 key → 'line'|'bar'（供模板绑定，避免 methods 在部分构建顺序下未挂上） */
    mixSeriesTypeColMap () {
      if (this.componentType !== 'lineBarMix') return {}
      const m = this.currentComponent?.chartSet?.chartStyle?.seriesTypeByCol || {}
      const out = {}
      this.mixLineBarValueColKeys.forEach((k) => {
        out[k] = m[k] === 'bar' ? 'bar' : 'line'
      })
      return out
    },
    /** 折线/面积/纵向柱/折柱混合：X 轴标签旋转（侧栏数字框绑定） */
    xAxisLabelRotatePaneValue () {
      if (!['line', 'areaLine', 'verticalBar', 'lineBarMix'].includes(this.componentType)) return 0
      const r = Number(this.currentComponent?.chartSet?.chartStyle?.xAxisLabelRotate)
      return Number.isFinite(r) ? r : 0
    },
    /** 旋转时底部留白：get/set + $set，保证 Vue2 与子组件 config 同步更新 */
    xAxisLabelRotateBottomPercentModel: {
      get () {
        if (!['line', 'areaLine', 'verticalBar', 'lineBarMix'].includes(this.componentType)) return 5
        const cs = this.currentComponent?.chartSet?.chartStyle
        if (!cs) return 5
        const p = Number(cs.xAxisLabelRotateBottomPercent)
        return Number.isFinite(p) ? p : 5
      },
      set (val) {
        if (!['line', 'areaLine', 'verticalBar', 'lineBarMix'].includes(this.componentType)) return
        const cs = this.currentComponent?.chartSet?.chartStyle
        if (!cs) return
        const n = Number(val)
        const pct = Number.isFinite(n) ? Math.min(80, Math.max(5, Math.round(n))) : 5
        this.$set(cs, 'xAxisLabelRotateBottomPercent', pct)
      },
    },
    currentTableData () {
      return this.currentChartData?.length ? this.currentChartData.slice(1) : []
    },
    componentType () {
      return this.currentComponent?.chartComponent
    },
    currentComponentStyle () {
      return this.currentComponent.chartSet
    },
    isMultipleChartData () {
      return !!this.currentChartData?.[0]?.labelName
    },
    currentChartData () {
      return this.currentComponent?.chartViewData?.chartData
    },
    /** 图片组件 · 自定义：上传组件与 chartData[1].col_0（OSS URL）双向绑定 */
    imageBlockPictureUrlModel: {
      get () {
        if (this.currentComponent?.chartComponent !== 'imageBlock') return ''
        const rows = this.currentComponent?.chartViewData?.chartData
        if (!Array.isArray(rows) || rows.length < 2) return ''
        const v = rows[1]?.col_0
        return v != null && String(v).trim() !== '' ? String(v).trim() : ''
      },
      set (val) {
        if (this.currentComponent?.chartComponent !== 'imageBlock') return
        const cvd = this.currentComponent.chartViewData
        if (!cvd) return
        const url = val != null && val !== '' ? String(val).trim() : ''
        if (!Array.isArray(cvd.chartData) || cvd.chartData.length < 2) {
          this.$set(cvd, 'chartData', _.cloneDeep(INIT_IMAGE_BLOCK_CHART_DATA))
        }
        if (!cvd.chartData[1] || typeof cvd.chartData[1] !== 'object') {
          this.$set(cvd.chartData, 1, _.cloneDeep(INIT_IMAGE_BLOCK_CHART_DATA[1]))
        }
        this.$set(cvd.chartData[1], 'col_0', url)
        cvd.initDataFlag = 0
        this.uniqueKey += 1
      },
    },
    supportsComponentChartTheme () {
      const comp = this.currentComponent
      if (!comp || this.isScreenSettingsPanel) return false
      const t = comp.chartComponent
      return Boolean(t && CHART_THEME_COMPONENT_TYPES.includes(t))
    },
    componentChartColorsModel: {
      get () {
        const c = this.currentComponent
        if (!c || this.isScreenSettingsPanel) return 'inherit'
        const fromSet = c.chartSet?.chartColors
        const fromRoot = c.chartColors
        const v = fromSet != null && fromSet !== '' ? fromSet : fromRoot
        return v != null && v !== '' ? v : 'inherit'
      },
      set (val) {
        const c = this.currentComponent
        if (!c || this.isScreenSettingsPanel) return
        const cs = c.chartSet
        if (!cs) return
        if (val === 'inherit') {
          this.$delete(cs, 'chartColors')
          if (Object.prototype.hasOwnProperty.call(c, 'chartColors')) {
            this.$delete(c, 'chartColors')
          }
        } else {
          this.$set(cs, 'chartColors', val)
          if (Object.prototype.hasOwnProperty.call(c, 'chartColors')) {
            this.$delete(c, 'chartColors')
          }
        }
      },
    },
    titleFontFamilyModel: {
      get () {
        if (this.isScreenSettingsPanel) return ''
        const s = this.currentComponent?.chartSet?.titleStyle
        if (!s) return ''
        return s.fontFamily ?? ''
      },
      set (val) {
        if (this.isScreenSettingsPanel) return
        const s = this.currentComponent?.chartSet?.titleStyle
        if (!s) return
        this.$set(s, 'fontFamily', val || '')
      },
    },
    /** 菜单 Tab：字体下拉与「标题」同一套 ChartFontFamilySelect + title-config-fontfamily */
    compositeTabBarFontFamilyModel: {
      get () {
        if (this.componentType !== 'compositeTabBar') return ''
        const b = this.currentComponent?.chartSet?.barStyle
        if (!b) return ''
        return b.fontFamily ?? ''
      },
      set (val) {
        if (this.componentType !== 'compositeTabBar') return
        this.ensureCompositeBarStyle('fontFamily', val || '')
      },
    },
    compositeTabBarActivePresentationModel: {
      get () {
        if (this.componentType !== 'compositeTabBar') return 'color'
        const b = this.currentComponent?.chartSet?.barStyle
        return b && b.activePresentation === 'template' ? 'template' : 'color'
      },
      set (val) {
        if (this.componentType !== 'compositeTabBar') return
        this.ensureCompositeBarStyle('activePresentation', val === 'template' ? 'template' : 'color')
      },
    },
    compositeTabBarActiveTemplateStretchModel: {
      get () {
        if (this.componentType !== 'compositeTabBar') return true
        const b = this.currentComponent?.chartSet?.barStyle
        return !(b && b.activeTemplateStretch === false)
      },
      set (val) {
        if (this.componentType !== 'compositeTabBar') return
        this.ensureCompositeBarStyle('activeTemplateStretch', !!val)
      },
    },
    mapVisualMapTitleModel: {
      get () {
        const t = this.currentComponent?.chartSet?.chartStyle?.visualMapOption?.text
        return Array.isArray(t) && t.length ? t[0] : ''
      },
      set (val) {
        const cs = this.currentComponent?.chartSet?.chartStyle
        if (!cs) return
        if (!cs.visualMapOption) {
          this.$set(cs, 'visualMapOption', { type: 'piecewise', pieces: [], text: [] })
        }
        this.$set(cs.visualMapOption, 'text', val ? [val] : [])
      },
    },
    mapVisualPiecesForEdit () {
      const p = this.currentComponent?.chartSet?.chartStyle?.visualMapOption?.pieces
      return Array.isArray(p) ? p : []
    },
    borderTemplateStretchModel: {
      get () {
        return this.currentComponent?.chartSet?.borderStyle?.borderTemplateStretch !== false
      },
      set (val) {
        if (this.isScreenSettingsPanel) return
        const b = this.currentComponent?.chartSet?.borderStyle
        if (!b) return
        this.$set(b, 'borderTemplateStretch', val)
      },
    },
    /** 时间组件「显示内容」各片段是否勾选（用 computed 供模板绑定，避免仅 methods 未挂载时报错） */
    timeDisplayPartChecked () {
      const td = this.currentComponent?.chartSet?.timeDisplay
      const on = (k) => !td || td[k] !== false
      return {
        year: on('year'),
        month: on('month'),
        day: on('day'),
        hour: on('hour'),
        minute: on('minute'),
        second: on('second'),
      }
    },
    /** 勾选变更（用 computed 返回闭包，避免部分环境下 methods 未挂到实例导致 @change 报错） */
    timeDisplayPartChange () {
      return (key, val) => {
        const cs = this.currentComponent && this.currentComponent.chartSet
        if (!cs) return
        const tdDef = { year: true, month: true, day: true, hour: true, minute: true, second: true }
        if (!cs.timeDisplay) {
          this.$set(cs, 'timeDisplay', { ...tdDef })
        }
        this.$set(cs.timeDisplay, key, !!val)
      }
    },
  },
  watch: {
    currentComponent: {
      handler: function (newValue, oldValue) {
        this.needUpdateMapRelate = false
        const switchedComponent = !oldValue || oldValue.addSn !== newValue.addSn
        this._paneConfigSwitchedComponent = switchedComponent
        this.componentSizeSet = {
          x: this.currentComponent.chartX,
          y: this.currentComponent.chartY,
          w: this.currentComponent.chartWidth,
          h: this.currentComponent.chartHeight,
        }

        if (this.panelType === 'composite' && newValue.chartComponent === 'compositeTabBar' && newValue.chartSet && !this.isScreenSettingsPanel) {
          if (!newValue.chartSet.tabs) this.$set(newValue.chartSet, 'tabs', [])
          if (switchedComponent) {
            this.$set(newValue.chartSet, 'barStyle', mergeCompositeTabBarBarStyle(newValue.chartSet.barStyle))
            this.loadScreenSelector()
          }
        }

        if (newValue.chartComponent === 'imageBlock' && newValue.chartSet) {
          if (newValue.chartSet.dataSource == null || newValue.chartSet.dataSource === '') {
            this.$set(newValue.chartSet, 'dataSource', 'customize')
          }
          if (this.panelType === 'composite' && newValue.chartSet.dataSource === 'indicatorLib') {
            this.$set(newValue.chartSet, 'dataSource', 'customize')
          }
        }

        if (newValue.chartComponent === 'timeClock' && newValue.chartSet) {
          const tdDef = { year: true, month: true, day: true, hour: true, minute: true, second: true }
          if (!newValue.chartSet.timeDisplay) {
            this.$set(newValue.chartSet, 'timeDisplay', { ...tdDef })
          } else {
            Object.keys(tdDef).forEach((k) => {
              if (newValue.chartSet.timeDisplay[k] === undefined) {
                this.$set(newValue.chartSet.timeDisplay, k, true)
              }
            })
          }
        }

        // 判断组件是否关联地图，
        if (this.currentComponent.chartSet?.chartStyle?.linkMap) {
          // 通过匹配等待同步的缓存，检测当前组件关联的地图组件行政区划是否修改
          const isFindMe = this.needSyncCache[this.currentComponent.addSn]
          if (isFindMe) {
            if (isFindMe !== this.currentComponent.chartSet.chartStyle.map) {
              this.needUpdateMapRelate = true
            }
          }
        }
        // 组件使用指标库：仅在切换选中组件时初始化，避免每次改 dataIndicator 都 $set 列表打断 el-select 与图表 mixin 的监听
        if (switchedComponent && newValue.chartViewData && needIndexComponent(newValue.chartComponent)) {
          const list = newValue.chartViewData?.selectedIndicatorList ?? []
          this.$set(newValue.chartViewData, 'selectedIndicatorList', list)
          if (!newValue.chartViewData?.selectedIndicatorList?.length) {
            newValue.chartViewData.selectedIndicatorList.push(_.cloneDeep(this.initIndicator))
          }
          if (newValue.chartComponent === 'filterBlock' && newValue.chartViewData.selectedIndicatorList.length > 1) {
            this.$set(newValue.chartViewData, 'selectedIndicatorList', [newValue.chartViewData.selectedIndicatorList[0]])
          }
          // 指标库：补拉下拉；地图组件依赖当前 map，每次点选组件都重拉以保证与已选 id 一致、el-select 能回显
          if (newValue.chartSet?.dataSource === 'indicatorLib') {
            const needFetch = newValue.dataIndicatorList == null || newValue.chartComponent === 'mapChart' || newValue.chartComponent === 'filterBlock'
            if (needFetch) {
              this.fetchIndicatorListForCurrentComponent()
            }
          }
        }

        this.$nextTick(async () => {
          this.form.panelHeight = this.currentComponent.panelHeight
          this.form.panelWidth = this.currentComponent.panelWidth
          // 设置 色卡、大屏背景、组件边框 的模板回填
          if (this.isScreenSettingsPanel) {
            // 大屏设置
            this.handleThemeColor(this.currentComponent.chartColors)
            if (this.currentComponent.backgroundType === 2) {
              this.handleBackground(this.currentComponent.background)
            }
          } else {
            this.theMax = this.currentComponent.chartSet?.chartStyle?.max
            const borderTpl = this.currentComponentStyle?.borderStyle?.borderTemplate
            if (borderTpl) {
              this.handleBorder(borderTpl)
            }
            // 仅在切换选中组件时同步 initChartData，避免每次改指标触发整块侧栏逻辑、干扰 el-select 展示
            if (this._paneConfigSwitchedComponent && this.currentComponent.chartViewData) {
              this.initChartData = _.cloneDeep(this.currentComponent.chartViewData.chartData)
            }
          }
        })
      },
      deep: true,
    },
    componentType: {
      handler: async function (newValue, oldValue) {
        // 独立数字组件, 设置其边框样式
        if (['independentNumber'].includes(newValue)) {
          this.$nextTick(async () => {
            this.handleIndependentNumberSelectType(this.currentComponent.chartSet.borderStyle.numberBorderType)
          })
        }
        // 边框组件, 设置边角样式
        if (['borderBlock'].includes(newValue) && this.currentComponent.chartSet.chartStyle.hasCorner) {
          this.$nextTick(async () => {
            this.handleBorderSelectType(this.currentComponent.chartSet.chartStyle.borderType)
          })
        }
      },
      deep: true,
    },
  },
  mounted () {
    this.init()
  },

  methods: {
    notifyParentRefreshChartIndicator () {
      this.$nextTick(() => {
        // 显式事件通知编辑页，避免侧栏与画布之间隔了包装组件时 $parent 不是 edit.vue 导致不拉数
        this.$emit('refresh-chart-indicator')
        this.$forceUpdate()
      })
    },
    // 整行替换 + 通知编辑页父组件通过 ref 拉数（绕过 Vue2 对 props 深层变更的监听问题）
    normalizeIndicatorValueAtRow (rowIndex, val) {
      const comp = this.currentComponent
      const list = comp?.chartViewData?.selectedIndicatorList
      if (!list || !list[rowIndex]) return
      const opts = comp.dataIndicatorList || []
      const matched = opts.find(o => String(o.value) === String(val))
      const next = matched ? matched.value : val
      const prevRow = list[rowIndex]
      this.$set(list, rowIndex, Object.assign({}, prevRow, { dataIndicator: next }))
      this.notifyParentRefreshChartIndicator()
    },
    /** 折柱混合图：设置某数据列为折线或柱状 */
    setMixSeriesTypeCol (colKey, val) {
      const cs = this.currentComponent.chartSet.chartStyle
      if (!cs.seriesTypeByCol || typeof cs.seriesTypeByCol !== 'object') {
        this.$set(cs, 'seriesTypeByCol', {})
      }
      this.$set(cs.seriesTypeByCol, colKey, val === 'bar' ? 'bar' : 'line')
    },
    // 检查指标是否已被其它行占用（当前行已选中的项不禁用，否则 el-select 无法改选）
    checkIndexDisable (item, rowIndex) {
      const list = this.currentComponent.chartViewData.selectedIndicatorList || []
      return list.some((bar, idx) => idx !== rowIndex && String(bar?.dataIndicator) === String(item.value))
    },
    // 拉取当前组件的指标候选项（地图依赖行政区划 map 参数）
    async fetchIndicatorListForCurrentComponent () {
      const comp = this.currentComponent
      if (!comp?.chartComponent || !needIndexComponent(comp.chartComponent)) return
      if (comp.chartSet?.dataSource !== 'indicatorLib') return
      const params = {
        indicatorChart: indicatorChartTypeForApi(comp.chartComponent),
        indicatorType: 1,
        panelSn: this.screenId,
      }
      if (comp.chartComponent === 'mapChart' && comp.chartSet?.chartStyle?.map?.length) {
        params.map = comp.chartSet.chartStyle.map.join('/')
      }
      this.$set(comp, 'dataIndicatorList', await getDataIndicatorApi(params))
      alignSelectedIndicatorsWithOptionValues(this, comp)
    },
    // 阻止键盘事件向上冒泡
    handleKeyDown (e) {
      e.stopPropagation()
    },
    async init () {
      // 初始化配置项并回填
      const list = await getScreenListApi()
      this.screenList = list.filter(item => {
        return item.panelSn !== this.screenId && item.panelType !== 'composite'
      })
    },
    handleScreenSizeChange (val) {
      const map = {
        '16:9': { w: 1920, h: 1080 },
        '4:3': { w: 1920, h: 1440 },
        custom: { w: 1920, h: 1080 },
      }
      if (this.val !== 'custom') {
        this.form.panelWidth = map[val].w
        this.form.panelHeight = map[val].h
        this.currentComponent.panelWidth = map[val].w
        this.currentComponent.panelHeight = map[val].h
      }
    },
    // 设置背景方式
    handleBackgroundType (val) {
      switch (val) {
        case 1:
          this.currentComponent.background = '#071228'
          break
        case 2:
          this.currentComponent.background = 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background1.png'
          break
        default:
          this.currentComponent.background = ''
          break
      }
    },
    // 选择背景模板，回填模板图片
    handleBackground (val) {
      this.$refs.selectTemplate
        .$el.children[0]
        .children[0]
        .setAttribute(
          'style',
				`background: url(${val}) no-repeat;background-position: 10px center; background-size: 80% 80%;text-indent: 30px;
        width: 220px; height: 80px;`,
        )
    },

    // 选择组件配色，回填颜色图片
    handleThemeColor (val) {
      const optionsImg = this.COLOR_LIST
      const i = optionsImg.find((item) => item.label === val).number
      const url = `https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/color${i}.svg`
      this.$refs.selectColor.$el.children[0].children[0].setAttribute('style', `background: url(${url}) no-repeat;background-position: 10px center; background-size: 80% 80%;text-indent: 30px;`)
    },

    // 选择独立数组组件边框样式，回填边框样式
    handleIndependentNumberSelectType (val) {
      const url = `https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/numberBorderType${val}.svg`
      this.$refs.independentNumberSelectType.$el.children[0].children[0].setAttribute('style', `background: url(${url}) no-repeat;background-position: 10px center; background-size: 80% 80%;text-indent: 30px;background-color: #fff;`)
    },

    // 边框组件边框样式，回填边角样式
    handleBorderSelectType (val) {
      const url = `https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/tempBorderType${val}.svg`
      this.$refs.borderSelectType.$el.children[0].children[0].setAttribute('style', `background: url(${url}) no-repeat;background-position: 10px center; background-size: 80% 80%;text-indent: 30px; background-color: #fff;`)
    },

    // 如果显示边角 回填边角样式
    handleChangeHasCorner (val) {
      if (val) {
        this.$nextTick(async () => {
          this.handleBorderSelectType(this.currentComponent.chartSet.chartStyle.borderType)
        })
      }
    },

    // 数据确认(自定义数据)
    async handleDataConfirm (data, setAxis) {
      this.currentComponent.chartViewData.initDataFlag = 0
      this.currentComponent.chartViewData.chartData = data
      // 双轴模式下，把列→轴的映射存入 axisConfig（独立于 chartData 存储）
      if (this.currentComponent.chartSet.chartStyle.doubleAxis) {
        this.$set(this.currentComponent.chartSet.chartStyle, 'axisConfig', setAxis || {})
      }

      const params = _.cloneDeep(this.currentComponent.chartViewData)
      params.chartData = JSON.stringify(params.chartData)
      params.initData = JSON.stringify(params.initData)
      await saveComponentDataApi(params)
      this.uniqueKey += 1 // 解决表头数据更新但表头不更新

      // 地图修改行政区划后，提示需要在数据再次保存后清除
      if (this.componentType === 'mapChart') {
        this.currentComponent.chartSet.chartStyle.mapLocalBak = this.currentComponent.chartSet.chartStyle.map.join('/')
        this.currentComponent.chartSet.chartStyle.mapChangeTip = undefined
      }

      // 在确认数据之后，将榜单图的最大值设为「首行数据」与「当前已填最大值」的较大者（表格式或 x/y 列）
      if (this.componentType === 'rank' && data?.length > 1) {
        const row = data[1]
        const raw = row.col_1 !== undefined && row.col_1 !== '' ? row.col_1 : (row.y_0 ?? row.y)
        const dm = Number(raw)
        const cur = Number(this.currentComponent.chartSet.chartStyle.max)
        const user = Number.isFinite(cur) && cur > 0 ? cur : 0
        this.currentComponent.chartSet.chartStyle.max = Math.max(Number.isFinite(dm) ? dm : 0, user)
      }
    },

    handleManageData () {
      if (this.panelType === 'composite') {
        this.$message.warning('组合大屏壳组件不支持管理数据')
        return
      }
      this.dialogVisible = true
    },
    ensureCompositeBarStyle (key, val) {
      const cs = this.currentComponent.chartSet
      if (!cs.barStyle) {
        this.$set(cs, 'barStyle', mergeCompositeTabBarBarStyle(null))
      }
      this.$set(cs.barStyle, key, val)
    },
    addCompositeTab () {
      const cs = this.currentComponent.chartSet
      if (!cs.tabs) this.$set(cs, 'tabs', [])
      const id = `t_${randomString()}_${Date.now()}`
      cs.tabs.push({
        tabId: id,
        label: '新页签',
        type: 'panel',
        panelSn: '',
        url: '',
        urlInset: { ...COMPOSITE_TAB_URL_INSET_DEFAULTS },
      })
    },
    onCompositeTabTypeChange (tab, val) {
      if (String(val) === 'url') {
        const d = normalizeCompositeTabUrlInset(tab)
        this.$set(tab, 'urlInset', { ...d })
      }
    },
    compositeTabUrlInsetValue (tab, key) {
      return normalizeCompositeTabUrlInset(tab)[key]
    },
    setCompositeTabUrlInset (tab, key, val) {
      const base = normalizeCompositeTabUrlInset(tab)
      if (!tab.urlInset || typeof tab.urlInset !== 'object') {
        this.$set(tab, 'urlInset', { ...base })
      }
      let n = Number(val)
      if (!Number.isFinite(n)) n = 0
      n = Math.max(0, Math.min(5000, Math.floor(n)))
      this.$set(tab.urlInset, key, n)
    },
    removeCompositeTab (idx) {
      const tabs = this.currentComponent.chartSet.tabs
      if (!tabs || tabs.length <= 1) {
        this.$message.warning('至少保留一个页签')
        return
      }
      const removed = tabs[idx]
      const gid = this.currentComponent.chartSet.groupId
      tabs.splice(idx, 1)
      // 编辑态使用全局 scope（仅在画布预览/嵌套渲染时才需要隔离 scope）
      if (removed && gid && String(getActiveTabId(gid, 'global') || '') === String(removed.tabId)) {
        setActiveTabId(gid, tabs[0] && tabs[0].tabId != null ? String(tabs[0].tabId) : '', 'global')
      }
    },
    async loadScreenSelector () {
      try {
        const list = await getScreenListApi()
        const cur = this.screenConfig?.panelSn
        // 允许选择组合大屏，但排除自身
        this.screenSelectorOptions = (list || []).filter((i) => i && i.panelSn !== cur)
      } catch (e) {
        this.screenSelectorOptions = []
      }
    },
    formatScreenSelectorLabel (row) {
      const name = row && row.panelName != null ? String(row.panelName) : ''
      const t = row && row.panelType === 'composite' ? '（组合）' : ''
      return `${name}${t}`
    },
    onCompositeTabPanelSelectFocus (tab) {
      if (this.panelType !== 'composite' || this.componentType !== 'compositeTabBar') return
      this.$set(tab, '_compositeTabPrevSn', tab.panelSn)
    },
    async onCompositeTabPanelSnChange (tab) {
      if (this.panelType !== 'composite' || this.componentType !== 'compositeTabBar') return
      const rootSn = this.screenConfig?.panelSn
      if (!rootSn) return
      if (String(tab?.type || 'panel') === 'url') return
      const sn = tab.panelSn
      if (sn == null || sn === '') return
      const tabs = this.currentComponent.chartSet.tabs || []
      const targets = tabs
        .map((t) => (t && t.panelSn != null && t.panelSn !== '' ? t.panelSn : ''))
        .filter(Boolean)
      const { ok, message } = await validateCompositeTabOneLevelNesting(rootSn, targets)
      if (ok) return
      this.$message.warning(message)
      const prev = Object.prototype.hasOwnProperty.call(tab, '_compositeTabPrevSn')
        ? tab._compositeTabPrevSn
        : ''
      this.$set(tab, 'panelSn', prev === undefined || prev === null ? '' : prev)
    },
    changeComponentTitle (value) {
      this.currentComponent.chartTitle = value
    },
    handleChangeMax () {
      if (this.currentComponent.chartSet) {
        this.currentComponent.chartSet.chartStyle.max = +this.theMax
      }
    },

    // 标题样式回填（仅边框物料等存在 borderTemplate 下拉时才有 ref）
    handleBorder (val) {
      const ref = this.$refs.borderTemplate
      if (!ref || !ref.$el || !ref.$el.children || !ref.$el.children[0]) return
      const inner = ref.$el.children[0].children && ref.$el.children[0].children[0]
      if (!inner || !inner.setAttribute) return
      inner.setAttribute(
        'style',
        `background: url(${val}) no-repeat;background-position: 10px center; background-size: 80% 80%;text-indent: 30px;
         width: 220px; height: 30px;`,
      )
    },
    handleBorderType (val) {
      if (val === 'none') {
        this.currentComponent.chartSet.borderStyle.borderTemplate = ''
      } else if (val === 'template') {
        const b = this.currentComponent.chartSet.borderStyle
        if (b.borderTemplateStretch === undefined) {
          this.$set(b, 'borderTemplateStretch', true)
        }
      }
    },
    handleClearJump () {
      this.currentComponent.jumpDelaySecond = null
    },
    handleSubmit () {
      this.$refs.screenSizeForm.validate()
    },

    handleLinkMapSwitch (val) {
      if (val) { // 打开关联地图
        // 备份单数据源的数据
        this.chartDataBak = _.cloneDeep(this.currentComponent.chartViewData.chartData)
      } else { // 关闭关联地图
        this.currentComponent.chartSet.chartStyle.linkMap = undefined
        if (this.chartDataBak) {
          this.currentComponent.chartViewData.chartData = _.cloneDeep(this.chartDataBak)
        } else {
          this.currentComponent.chartViewData.chartData = _.cloneDeep([TABLE_HEADER, TABLE_ROW])
        }
      }
    },

    // 关联地图的组件重新获取地图数据
    handleUpdateMapData () {
      this.handleLinkMapChange(this.currentComponent.chartSet.chartStyle.linkMap)
      this.needUpdateMapRelate = false
      this.needSyncCache[this.currentComponent.addSn] = undefined
    },

    // 组件选择关联地图组件
    async handleLinkMapChange (mapAddSn) {
      const map = this.mapComponentList.find(bar => bar.addSn === mapAddSn).chartSet.chartStyle.map.join('/')
      const mapJsonRes = await fetch(`https://kylin-static.oss-cn-hangzhou.aliyuncs.com/common/geojson/${map}.json`)
      const mapJson = await mapJsonRes.json()
      const mapLabelList = mapJson.features.map(bar => bar.properties.name)

      const multipleDataList = mapLabelList.map(labelName => {
        return {
          labelName,
          setAxis: {},
          realChartData: _.cloneDeep(MULTIPLE_DATA_INIT),
        }
      })
      this.currentComponent.chartViewData.chartData = multipleDataList
      this.currentComponent.chartSet.chartStyle.map = map

      // 记录地图组件与其他组件依赖关系
      if (this.relateMap[mapAddSn]) {
        this.relateMap[mapAddSn].push(this.currentComponent.addSn)
        this.relateMap[mapAddSn] = [...new Set(this.relateMap[mapAddSn])]
      } else {
        this.relateMap[mapAddSn] = [this.currentComponent.addSn]
      }
    },
    // 获取表格数据
    getCurTableData (table) {
      return table.slice(1)
    },
    handleRankRate (value) {
      if (!value && this.componentType === 'rank') {
        this.currentComponent.chartSet.chartStyle.rateType = ''
      }
    },
    // 地图行政区划更新，将相关联的组件加入到等待同步的缓存中
    async handleMapSourceChange (map) {
      // 获取原始行政区划值
      const oldMap = this.currentComponent.chartSet.chartStyle.map
      const mapChanged = oldMap && map.join('/') !== oldMap.join('/')

      // 地图组件 修改行政区划 并且不是初始数据 不是原来的行政区域 需提示，
      if (!this.currentComponent.chartViewData.initDataFlag && map.join('/') !== this.currentComponent.chartSet.chartStyle.mapLocalBak) {
        this.currentComponent.chartSet.chartStyle.mapChangeTip = true
      } else {
        this.currentComponent.chartSet.chartStyle.mapChangeTip = false
      }

      // 地图行政区划更新后，将相关联的组件加入到等待同步的缓存中
      const updateComp = this.relateMap[this.currentComponent.addSn] || []
      updateComp.forEach(bar => {
        this.needSyncCache[bar] = map.join('/')
      })

      // 地图行政区划变更后，重新获取指标列表（仅当真正修改了行政区划且使用指标库时）
      if (mapChanged && this.currentComponent.chartSet.dataSource === 'indicatorLib') {
        const params = {
          indicatorChart: this.currentComponent.chartComponent,
          indicatorType: 1,
          panelSn: this.$route.params.id || this.$route.query.id,
          map: map.join('/'),
        }
        this.currentComponent.dataIndicatorList = await getDataIndicatorApi(params)
        // 清空已选的指标，避免选择已失效的指标
        this.currentComponent.chartViewData.selectedIndicatorList = [{ dataIndicator: '' }]
      }
    },

    // 组件尺寸赋值
    setComponentSize () {
      this.componentSizeSet.w = this.componentSizeSet.w > this.screenConfig.panelWidth
        ? this.screenConfig.panelWidth
        : this.componentSizeSet.w
      this.componentSizeSet.h = this.componentSizeSet.h > this.screenConfig.panelHeight
        ? this.screenConfig.panelHeight
        : this.componentSizeSet.h

      this.componentSizeSet.x = this.componentSizeSet.x > this.screenConfig.panelWidth - this.componentSizeSet.w
        ? this.screenConfig.panelWidth - this.componentSizeSet.w
        : this.componentSizeSet.x

      this.componentSizeSet.y = this.componentSizeSet.y > this.screenConfig.panelHeight - this.componentSizeSet.h
        ? this.screenConfig.panelHeight - this.componentSizeSet.h
        : this.componentSizeSet.y

      this.currentComponent.chartX = +this.componentSizeSet.x
      this.currentComponent.chartY = +this.componentSizeSet.y
      this.currentComponent.chartWidth = +this.componentSizeSet.w
      this.currentComponent.chartHeight = +this.componentSizeSet.h
    },

    mapEnsureVisualMapOption () {
      const cs = this.currentComponent?.chartSet?.chartStyle
      if (!cs || this.componentType !== 'mapChart') return
      if (!cs.visualMapOption) {
        this.$set(cs, 'visualMapOption', { type: 'piecewise', pieces: [], text: [] })
      }
      if (!Array.isArray(cs.visualMapOption.pieces)) {
        this.$set(cs.visualMapOption, 'pieces', [])
      }
      if (!Array.isArray(cs.visualMapOption.text)) {
        this.$set(cs.visualMapOption, 'text', [])
      }
    },
    mapOnVisualMapSwitch (on) {
      this.mapEnsureVisualMapOption()
      if (on && !this.currentComponent.chartSet.chartStyle.visualMapOption.pieces.length) {
        this.mapAddVisualPieceRow()
      }
    },
    mapAddVisualPieceRow () {
      this.mapEnsureVisualMapOption()
      this.currentComponent.chartSet.chartStyle.visualMapOption.pieces.push({
        min: '',
        max: '',
        label: '',
        color: '#5470c6',
      })
    },
    mapRemoveVisualPieceRow (idx) {
      this.mapEnsureVisualMapOption()
      const rows = this.currentComponent.chartSet.chartStyle.visualMapOption.pieces
      if (!rows || rows[idx] === undefined) return
      if (rows.length <= 1) return
      rows.splice(idx, 1)
    },
    /** X 轴标签旋转：必须用 $set，避免 Vue2 新增字段不触发子组件更新 */
    setXAxisLabelRotate (v) {
      if (!['line', 'areaLine', 'verticalBar', 'lineBarMix'].includes(this.componentType)) return
      const cs = this.currentComponent?.chartSet?.chartStyle
      if (!cs) return
      const n = Number(v)
      const rot = Number.isFinite(n) ? n : 0
      const prevRot = Number(cs.xAxisLabelRotate)
      const prev = Number.isFinite(prevRot) ? prevRot : 0
      this.$set(cs, 'xAxisLabelRotate', rot)
      // 从水平变为倾斜：底部留白默认 5；旧数据曾为 22 的同步改为 5
      const becameRotated = Math.abs(rot) > 1e-6 && Math.abs(prev) < 1e-6
      if (becameRotated) {
        const bp = cs.xAxisLabelRotateBottomPercent
        const bpNum = Number(bp)
        const legacyOrUnset =
          bp === undefined || bp === null || bp === '' || !Number.isFinite(bpNum) || bpNum === 22
        if (legacyOrUnset) {
          this.$set(cs, 'xAxisLabelRotateBottomPercent', 5)
        }
      }
    },
    handleFontStyle (style) {
      // 富文本：字号/颜色由 v-model 直接写入真实值，richText.vue watcher 负责应用到选区/全文
      if (this.componentType === 'richText' && (style === 'fontSize' || style === 'color')) return
      const fs = this.currentComponent.chartSet.titleStyle.fontStyle
      // 富文本 B/I/U/S：必须可在 true/false 间切换；原 Math.random() 永远为真，导致关不掉且指标态看似「点了没反应」
      if (
        this.componentType === 'richText' &&
        ['bold', 'italic', 'underline', 'strikeThrough'].includes(style)
      ) {
        const next = !isRichFontStyleFlagOn(fs[style])
        this.$set(fs, style, next)
        return
      }
      fs[style] = Math.random()
    },
    handleJustify (style) {
      this.currentComponent.chartSet.titleStyle.align = style
    },
    // 读取指标模式双轴下第 index 个指标的轴索引
    getIndicatorAxisIndex (index) {
      const axisConfig = this.currentComponent.chartSet.chartStyle.axisConfig
      return axisConfig && axisConfig['y_' + index] !== undefined ? axisConfig['y_' + index] : 0
    },
    // 设置指标模式双轴下第 index 个指标的轴索引
    setIndicatorAxisIndex (index, val) {
      if (!this.currentComponent.chartSet.chartStyle.axisConfig) {
        this.$set(this.currentComponent.chartSet.chartStyle, 'axisConfig', {})
      }
      this.$set(this.currentComponent.chartSet.chartStyle.axisConfig, `y_${index}`, val)
    },
    // 增加数据指标维度
    handleAddIndicator () {
      if (this.componentType === 'filterBlock') {
        this.$error('筛选组件仅支持一个指标，多条件请添加多个筛选组件')
        return
      }
      const empty = this.currentComponent.chartViewData.selectedIndicatorList?.every(item => !item.dataIndicator)
      if (empty) {
        this.$error('请选择数据指标之后再添加')
      }
      this.currentComponent.chartViewData.selectedIndicatorList.push(_.cloneDeep(this.initIndicator))
    },

    // 删除数据指标维度
    handleDelIndicator (index) {
      if (this.componentType === 'filterBlock') {
        this.$error('筛选组件仅支持一个指标，无法删除行；可清空「数据指标」或改用自定义')
        return
      }
      this.currentComponent.chartViewData.selectedIndicatorList.splice(index, 1)
      this.notifyParentRefreshChartIndicator()
    },
    /** 筛选组件：唯一指标下拉变更（含清空） */
    onFilterBlockIndicatorSelect (val) {
      const list = this.currentComponent.chartViewData.selectedIndicatorList
      if (!list?.length) {
        this.$set(this.currentComponent.chartViewData, 'selectedIndicatorList', [_.cloneDeep(this.initIndicator)])
      }
      const v = val === undefined || val === null ? '' : val
      this.normalizeIndicatorValueAtRow(0, v)
    },
    // 数据源切换
    handleDataSourceChange (value) {
      if (value === 'customize') {
        this.currentComponent.chartViewData.selectedIndicatorList = []
        this.currentComponent.chartViewData.showIndicator = false
        if (!this.currentComponent.chartViewData?.initData) {
          this.currentComponent.chartViewData.initData = componentInitDataMap.get(this.currentComponent.chartComponent)
        }
        this.currentComponent.chartViewData.chartData = _.cloneDeep(this.currentComponent.chartViewData.initData)
      } else if (value === 'indicatorLib') {
        const cvd = this.currentComponent.chartViewData
        if (!cvd.selectedIndicatorList?.length) {
          this.$set(cvd, 'selectedIndicatorList', [_.cloneDeep(this.initIndicator)])
        } else if (this.componentType === 'filterBlock' && cvd.selectedIndicatorList.length > 1) {
          this.$set(cvd, 'selectedIndicatorList', [cvd.selectedIndicatorList[0]])
        }
        this.fetchIndicatorListForCurrentComponent()
      }
    },
    // 输入签名名称改变的时候同时改变签名URL
    handleChangeSignName (value) {
      this.currentComponent.chartSet.chartStyle.signUrl = `${process.env.VUE_APP_SIGN_URL}/draw/${this.screenId}?name=${encodeURIComponent(value)}`
    },
    handleChangeFilterType (value) {
      // 获取当前非激活状态的筛选框
      const filterBlocks = this.screenData.filter(bar => bar.chartComponent === 'filterBlock' && !bar.active)
      const repeated = filterBlocks.some(bar => bar.chartSet.chartStyle.filterType === value)
      if (repeated) {
        this.$error('该类型的过滤器已存在，请更换类型')
        this.currentComponent.chartSet.chartStyle.filterType = ''
      } else {
        this.currentComponent.chartSet.chartStyle.filterType = value
        if (this.currentComponent.chartSet?.dataSource === 'indicatorLib') {
          this.$nextTick(() => this.notifyParentRefreshChartIndicator())
        }
      }
    },

  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.pane-config-wrap{
  display: flex;
  flex-direction: column;
  .composite-url-inset-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-top: 6px;
  }
  .composite-url-inset-label {
    width: 18px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.55);
  }
  ::v-deep .el-radio-button__inner{
    width: 110px;
    @media screen and (max-width: 1600px){
      width: 90px;
    }
  }
  .pane-name-icon {
    color: #3269ff;
  }
  .pane-name {
    margin-bottom: 8px;
    &-icon{
      margin-right: 8px;
      font-size: 24px;
    }
    &-title{
      font-weight: bold;
      font-size: 16px;
      vertical-align: 3px;
    }
  }

  .pane-config-container{
    height: 0;
    flex: 1;
    overflow: auto;
    .component-size{
      .option-size-label {
        display: inline-block;
        margin: 10px 12px 10px  0;
      }
      .opti-sub-label{
        display: inline-block;
        width: 20px;
        text-align: right;
        margin-right: 5px;
      }
      .el-input-number{
        width: 98px;
      }
    }
    .component-size,.size-config,.title-config,.color-config,.active-config,.style-config {
      padding-left: 20px;
    }
    .size-config{
      .size-width{
        .size-width-input{
          width: 130px;
          @media screen and (max-width: 1600px) {
            width: 100px;
          }
        }
      }
      .size-label {
        display: inline-block;
        margin: 10px 10px 10px  0;
      }
    }
    .option-label {
      display: inline-block;
      margin: 10px 12px 10px  0;
      width: 52px;
      text-align: right;
    }
    .option-label-slider {
      display: inline-block;
      margin: 5px 10px 0px  0;
    }

    .link-map-select{
      width: 170px;
      margin-left: 10px;
    }

    // 边框组件
    .border-config-item{
      display: flex;
      align-items: center;
      .el-color-picker{
        vertical-align: middle;
        margin-right: 5px;
      }
      .corner-switch,.border-input{
        margin-right: 5px;
      }
    }

    // 标题
    .title-config{
      .title-label-input{
        width: 236px;
      }

      &-color {
        margin:0  5px 0 64px;
      }
      &-fontsize {
        vertical-align: top;
      }
      &-font-row {
        margin-top: 8px;
      }
      &-fontfamily {
        margin-left: 10px;
        vertical-align: middle;
      }
      &-offset-row {
        margin-top: 10px;
        padding-top: 8px;
        border-top: 1px solid #ebeef5;
        .title-offset-controls {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 8px 12px;
          margin-left: 0;
          margin-top: 6px;
        }
        .title-offset-label {
          font-size: 12px;
          color: #606266;
          min-width: 28px;
        }
        .title-offset-input {
          width: 118px;
        }
        .title-offset-hint {
          margin: 8px 0 0 0;
          font-size: 12px;
          color: #909399;
          line-height: 1.4;
        }
      }

      .rich-text-style {
        display: inline-block;
        vertical-align: -10px;
      }
      .rich-config-color {
        margin-right: 5px;
      }
      .set-font-style {
        display: inline-block;
        width :238px;
        height: 32px;
        background-color: #fff;
        border-radius: 2px;
        margin-bottom: 5px;
        border:1px solid #e4e7ed;
        border-right: none;

        &-item{
          display: inline-block;
          width: 25%;
          height: 100%;
          text-align: center;
          line-height: 32px;
          border-right:1px solid #e4e7ed;
          cursor: pointer;
          &:hover {
            color: #258aff;
          }
        }

      }
      .set-position {
        margin-left: 5px;
        vertical-align: top;
        ::v-deep .el-radio-button__inner {
          width: 38px !important;
          padding: 8px;
        }
      }

      .set-rich-position {
        display: inline-block;
        width :116px;
        height: 32px;
        margin-left: 5px;
        background-color: #fff;
        border-radius: 2px;
        margin-bottom: 5px;
        vertical-align: 6px;
        border:1px solid #e4e7ed;
        border-right: none;
        vertical-align: 10px;

        &-item{
          display: inline-block;
          width: 33%;
          height: 100%;
          text-align: center;
          line-height: 32px;
          border-right:1px solid #e4e7ed;
          cursor: pointer;
          &:hover {
            color: #258aff;
          }
        }

      }

    }
    // 颜色
    .color-config {
      &-bgc {
        margin: 15px 10px;
      }
      &-hint {
        margin: 8px 10px 0 10px;
        font-size: 12px;
        color: #909399;
        line-height: 1.45;
      }
      &-select {
        margin-left: 10px;
        background-color: #fff;
        .color-block {
          display: inline-block;
          height: 20px;
          width: 20px;
        }
        .color-name {
          display:inline-block;
        }
      }
      .background-color {
        display: inline;
        .color-select {
          margin-left:10px;
          vertical-align: -10px;
        }
      }
      .background-template{
        .text {
          vertical-align: top;
        }
        .template-select {
          display: inline-block;
          &-setting {
            margin-left: 10px;
            background-color: #fff;
          }
        }
      }
      .background-img{
        display:flex;
        flex-flow:row nowrap;
        align-items:center;
        justify-content: flex-start;
        .option-label{
          display:block;
          width:70px;
          margin-right:20px;
        }
      }
    }
    // 交互
    .active-config {
      &-jump {
       margin-bottom: 10px;
      }
      .jump-delay {
        ::v-deep .el-input__suffix {
          line-height: 32px;
          right: 15px;
        }
      }
    }

    .style-config-border {
      .style-config-borderColor {
        vertical-align: middle;
      }
      .style-config-numberColor {
        margin-right: 5px;
        vertical-align: middle;

      }
      .style-config-rateColor {
        margin-left: 15px;
        vertical-align: middle;

      }
      .style-config-symbol-font{
        margin-left: 5px;
        width: 80px;
      }
      .style-config-symbolColor{
        margin-left: 5px;
        vertical-align: middle;
      }
      .style-config-symbol-input{
        margin-left: 5px;
        width: 60px;
      }
      .time-display-checkboxes {
        display: flex;
        flex-wrap: wrap;
        gap: 4px 12px;
        align-items: center;
        max-width: 220px;
        ::v-deep .el-checkbox {
          margin-right: 0;
        }
      }
      &.pie-topn-style-inline {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px 12px;
        .pie-topn-style-controls {
          display: inline-flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 8px;
        }
        .pie-topn-style-hint {
          font-size: 12px;
          color: #909399;
          white-space: nowrap;
        }
      }
      .set-template {
        padding-left: 64px;
        min-height: 36px;
        height: auto;
        overflow: visible;
        padding-bottom: 12px;
        ::v-deep .el-input {
          background-color: #fff !important;
        }
        .set-template-select {
          display: block;
          max-width: 100%;
        }
        .title-border-stretch-row {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          column-gap: 10px;
          row-gap: 8px;
          margin-top: 12px;
          padding-top: 12px;
          border-top: 1px solid #ebeef5;
          max-width: 100%;
          .option-label {
            margin: 0;
            flex: 0 0 auto;
          }
        }
        .title-border-stretch-switch {
          flex: 0 1 auto;
          ::v-deep .el-switch__label {
            font-size: 12px;
          }
          ::v-deep .el-switch__label * {
            font-size: 12px;
          }
        }
      }
    }

    // 数据管理
    :deep(.data-config){
      padding-right: 20px;
      .data-config-title{
        margin-top: 15px;
      }
      .map-change-tips{
        color: #FF9114;
        font-size: 14px;
        margin-bottom: 10px;
        display: flex;
        align-items: flex-start;
        i{
          font-size: 16px;
          margin-right: 5px;
          width: 16px;
          line-height: 24px;
        }
        span{
          flex: 1;
        }
      }
      .manage-table{
        margin-top: 10px;
        .el-table__header, .el-table__body{
          .el-table__cell{
            height: 32px;
            padding: 0 10px;
            font-size: 12px;
            .cell{
              padding: 0 !important;
              .cell-content{
                @include ellipsis(1);
                .axis-label {
                  color: #ccc;
                  display: inline-block;
                  margin-left: 10px;
                }
              }
            }
          }
        }

      }
    }
  }

  :deep(.el-slider){
    // padding: 0 50px;
    display:inline-block;
    width: 220px;
    vertical-align: middle;
    .el-slider__input {
       width: 105px;
    }
    .el-slider__runway.show-input{
      margin-right: 138px;
    }

  }
  :deep(.el-checkbox-group){
    display: inline-block;
  }

  :deep(.el-collapse) {
    border: none;
  }
  :deep(.el-collapse-item__header) {
    display: inline-block;
    i {
      float: left;
      line-height: 48px;
    }

  }
}
.map-visual-pieces-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.map-visual-piece-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}
.map-vm-inp {
  width: 76px;
}
.map-vm-label {
  width: 110px;
  min-width: 72px;
  flex: 1;
}
.map-vm-del {
  cursor: pointer;
  flex-shrink: 0;
}
.map-visual-hint {
  font-size: 12px;
  color: #909399;
  line-height: 1.45;
  margin: 8px 0 8px;
}
.data-indicator{
  display:flex;
  flex-flow:row nowrap;
  align-items: center;
  justify-content: flex-start;
  margin:10px 0;
  .indicator-label{
    display:block;
    margin-right:10px;
    width: 60px;
  }
  .data-config-item{
    // margin-bottom:10px;
    display:flex;
    align-items:center;
    justify-content: flex-start;
  }
  &.indicatior-icon{
    padding-left:70px;
    box-sizing:border-box;
  }
  .data-config-del,.data-config-add{
    width:24px;
    height:24px;
  }
  .indicator-axis-select{
    width: 56px;
    margin-right: 4px;
    ::v-deep .el-input__inner {
      padding: 0 4px;
    }
  }
}
.sign-name-config{
  .sign-name-config-item{
    display:flex;
    flex-flow:row nowrap;
    align-items:center;
    justify-content: flex-start;
    padding-right:40px;
    box-sizing:border-box;
    .option-label{
      display:block;
      width:90px;
    }
    .sign-content{
      flex:1;
      word-break: break-all;
      line-height:20px;
    }
  }
  .tips{
    padding-left:100px;
    box-sizing:border-box;
    margin:5px 0;
    color:#666;
    font-size:12px;
    line-height:18px;
    word-break: break-all;
  }
}
</style>
